export const DictionaryIllustrator_pt_BR = [
    {
        id: 18,
        label: 'Editar > Colar na frente',
        placement: 'MenuBar',
        name: 'Colar na frente',
    },
    {
        id: 19,
        label: 'Editar > Colar atrás',
        placement: 'MenuBar',
        name: 'Colar atrás',
    },
    {
        id: 20,
        label: 'Arquivo > Novo a partir do modelo...',
        placement: 'MenuBar',
        name: 'Novo a partir do modelo...',
    },
    {
        id: 22,
        label: 'Objeto > Transformar > Transformar novamente',
        placement: 'MenuBar',
        name: 'Transformar novamente',
    },
    {
        id: 23,
        label: 'Objeto > Agrupar',
        placement: 'MenuBar',
        name: 'Agrupar',
    },
    {
        id: 24,
        label: 'Objeto > Desagrupar',
        placement: 'MenuBar',
        name: 'Desagrupar',
    },
    {
        id: 25,
        label: 'Objeto > Caminho > Junção',
        placement: 'MenuBar',
        name: 'Junção',
    },
    {
        id: 26,
        label: 'Objeto > Caminho > Média...',
        placement: 'MenuBar',
        name: 'Média...',
    },
    {
        id: 28,
        label: 'Objeto > Bloquear > Seleção',
        placement: 'MenuBar',
        name: 'Seleção',
    },
    {
        id: 29,
        label: 'Objeto > Desbloquear tudo',
        placement: 'MenuBar',
        name: 'Desbloquear tudo',
    },
    {
        id: 30,
        label: 'Exibir > Visualização',
        placement: 'MenuBar',
        name: 'Visualização',
    },
    {
        id: 33,
        label: 'Exibir > Visualização de pixels',
        placement: 'MenuBar',
        name: 'Visualização de pixels',
    },
    {
        id: 34,
        label: 'Tipo > Opções de Tipo de área...',
        placement: 'MenuBar',
        name: 'Opções de Tipo de área...',
    },
    {
        id: 35,
        label: 'Exibir > Ajustar prancheta à janela',
        placement: 'MenuBar',
        name: 'Ajustar prancheta à janela',
    },
    {
        id: 36,
        label: 'Janela > Nova janela',
        placement: 'MenuBar',
        name: 'Nova janela',
    },
    {
        id: 37,
        label: 'Exibir > Réguas > Mostrar réguas',
        placement: 'MenuBar',
        name: 'Mostrar réguas',
    },
    {
        id: 38,
        label: 'Tipo > Tipo em um caminho > Fita 3D',
        placement: 'MenuBar',
        name: 'Fita 3D',
    },
    {
        id: 40,
        label: 'Tipo > Tipo em um caminho > Serrilha',
        placement: 'MenuBar',
        name: 'Serrilha',
    },
    {
        id: 42,
        label: 'Objeto > Organizar > Trazer para a frente',
        placement: 'MenuBar',
        name: 'Trazer para a frente',
    },
    {
        id: 43,
        label: 'Objeto > Organizar > Enviar para trás',
        placement: 'MenuBar',
        name: 'Enviar para trás',
    },
    {
        id: 48,
        label: 'Arquivo > Salvar como modelo...',
        placement: 'MenuBar',
        name: 'Salvar como modelo...',
    },
    {
        id: 50,
        label: 'Objeto > Ocultar > Seleção',
        placement: 'MenuBar',
        name: 'Seleção',
    },
    {
        id: 51,
        label: 'Objeto > Mostrar tudo',
        placement: 'MenuBar',
        name: 'Mostrar tudo',
    },
    {
        id: 52,
        label: 'Exibir > Guias > Criar guias',
        placement: 'MenuBar',
        name: 'Criar guias',
    },
    {
        id: 53,
        label: 'Exibir > Guias > Liberar guias',
        placement: 'MenuBar',
        name: 'Liberar guias',
    },
    {
        id: 54,
        label: 'Objeto > Transformar > Mover...',
        placement: 'MenuBar',
        name: 'Mover...',
    },
    {
        id: 55,
        label: 'Illustrator > Preferências > Guias inteligentes...',
        placement: 'MenuBar',
        name: 'Guias inteligentes...',
    },
    {
        id: 56,
        label: 'Objeto > Caminho composto > Criar',
        placement: 'MenuBar',
        name: 'Criar',
    },
    {
        id: 57,
        label: 'Objeto > Caminho composto > Liberar',
        placement: 'MenuBar',
        name: 'Liberar',
    },
    {
        id: 62,
        label: 'Tipo > Criar contornos',
        placement: 'MenuBar',
        name: 'Criar contornos',
    },
    {
        id: 63,
        label: 'Exibir > Tamanho real',
        placement: 'MenuBar',
        name: 'Tamanho real',
    },
    {
        id: 74,
        label: 'Objeto > Gráfico > Tipo...',
        placement: 'MenuBar',
        name: 'Tipo...',
    },
    {
        id: 75,
        label: 'Objeto > Gráfico > Dados...',
        placement: 'MenuBar',
        name: 'Dados...',
    },
    {
        id: 76,
        label: 'Objeto > Gráfico > Coluna...',
        placement: 'MenuBar',
        name: 'Coluna...',
    },
    {
        id: 77,
        label: 'Objeto > Gráfico > Design...',
        placement: 'MenuBar',
        name: 'Design...',
    },
    {
        id: 78,
        label: 'Objeto > Gráfico > Marcador...',
        placement: 'MenuBar',
        name: 'Marcador...',
    },
    {
        id: 83,
        label: 'Tipo > Tipo em um caminho > Arco-íris',
        placement: 'MenuBar',
        name: 'Arco-íris',
    },
    {
        id: 84,
        label: 'Arquivo > Configuração de documento...',
        placement: 'MenuBar',
        name: 'Configuração de documento...',
    },
    {
        id: 85,
        label: 'Exibir > Ocultar Imprimir lado a lado',
        placement: 'MenuBar',
        name: 'Ocultar Imprimir lado a lado',
    },
    {
        id: 86,
        label: 'Exibir > Ocultar pranchetas',
        placement: 'MenuBar',
        name: 'Ocultar pranchetas',
    },
    {
        id: 87,
        label: 'Tipo > Ajustar título',
        placement: 'MenuBar',
        name: 'Ajustar título',
    },
    {
        id: 95,
        label: 'Arquivo > Salvar uma cópia...',
        placement: 'MenuBar',
        name: 'Salvar uma cópia...',
    },
    {
        id: 98,
        label: 'Illustrator > Preferências > Tipo...',
        placement: 'MenuBar',
        name: 'Tipo...',
    },
    {
        id: 99,
        label: 'Illustrator > Preferências > Unidades...',
        placement: 'MenuBar',
        name: 'Unidades...',
    },
    {
        id: 100,
        label: 'Objeto > Organizar > Avançar',
        placement: 'MenuBar',
        name: 'Avançar',
    },
    {
        id: 101,
        label: 'Objeto > Organizar > Recuar',
        placement: 'MenuBar',
        name: 'Recuar',
    },
    {
        id: 109,
        label: 'Janela > Organizar > Minimizar janela',
        placement: 'MenuBar',
        name: 'Minimizar janela',
    },
    {
        id: 110,
        label: 'Janela > Organizar > Trazer tudo para a frente',
        placement: 'MenuBar',
        name: 'Trazer tudo para a frente',
    },
    {
        id: 113,
        label: 'Exibir > Guias > Limpar guias',
        placement: 'MenuBar',
        name: 'Limpar guias',
    },
    {
        id: 114,
        label: 'Exibir > Mostrar modelo',
        placement: 'MenuBar',
        name: 'Mostrar modelo',
    },
    {
        id: 115,
        label: 'Tipo > Mostrar caracteres ocultos',
        placement: 'MenuBar',
        name: 'Mostrar caracteres ocultos',
    },
    {
        id: 116,
        label: 'Tipo > Tipo em um caminho > Inclinar',
        placement: 'MenuBar',
        name: 'Inclinar',
    },
    {
        id: 117,
        label: 'Arquivo > Fechar tudo',
        placement: 'MenuBar',
        name: 'Fechar tudo',
    },
    {
        id: 119,
        label: 'Tipo > Tipo em um caminho > Gravidade',
        placement: 'MenuBar',
        name: 'Gravidade',
    },
    {
        id: 120,
        label: 'Objeto > Máscara de recorte > Criar',
        placement: 'MenuBar',
        name: 'Criar',
    },
    {
        id: 121,
        label: 'Objeto > Máscara de recorte > Liberar',
        placement: 'MenuBar',
        name: 'Liberar',
    },
    {
        id: 123,
        label: 'Tipo > Tipo em um caminho > Opções de Tipo no caminho...',
        placement: 'MenuBar',
        name: 'Opções de Tipo no caminho...',
    },
    {
        id: 127,
        label: 'Objeto > Pranchetas > Converter em pranchetas',
        placement: 'MenuBar',
        name: 'Converter em pranchetas',
    },
    {
        id: 133,
        label: 'Tipo > Texto encadeado > Criar',
        placement: 'MenuBar',
        name: 'Criar',
    },
    {
        id: 135,
        label: 'Exibir > Mais zoom',
        placement: 'MenuBar',
        name: 'Mais zoom',
    },
    {
        id: 136,
        label: 'Exibir > Menos zoom',
        placement: 'MenuBar',
        name: 'Menos zoom',
    },
    {
        id: 139,
        label: 'Editar > Configurações de cores...',
        placement: 'MenuBar',
        name: 'Configurações de cores...',
    },
    {
        id: 140,
        label: 'Illustrator > Preferências > Hifenização...',
        placement: 'MenuBar',
        name: 'Hifenização...',
    },
    {
        id: 141,
        label: 'Illustrator > Preferências > Plug-ins e discos de memória virtual...',
        placement: 'MenuBar',
        name: 'Plug-ins e discos de memória virtual...',
    },
    {
        id: 142,
        label: 'Selecionar > Cancelar seleção',
        placement: 'MenuBar',
        name: 'Cancelar seleção',
    },
    {
        id: 143,
        label: 'Exibir > Visualização de superimposição',
        placement: 'MenuBar',
        name: 'Visualização de superimposição',
    },
    {
        id: 144,
        label: 'Exibir > Nova exibição...',
        placement: 'MenuBar',
        name: 'Nova exibição...',
    },
    {
        id: 145,
        label: 'Exibir > Editar exibições...',
        placement: 'MenuBar',
        name: 'Editar exibições...',
    },
    {
        id: 146,
        label: 'Exibir > Encaixar no ponto',
        placement: 'MenuBar',
        name: 'Encaixar no ponto',
    },
    {
        id: 147,
        label: 'Exibir > Ocultar bordas',
        placement: 'MenuBar',
        name: 'Ocultar bordas',
    },
    {
        id: 148,
        label: 'Objeto > Expandir aparência',
        placement: 'MenuBar',
        name: 'Expandir aparência',
    },
    {
        id: 150,
        label: 'Exibir > Mostrar encadeamentos de texto',
        placement: 'MenuBar',
        name: 'Mostrar encadeamentos de texto',
    },
    {
        id: 154,
        label: 'Exibir > Guias > Ocultar guias',
        placement: 'MenuBar',
        name: 'Ocultar guias',
    },
    {
        id: 155,
        label: 'Exibir > Guias > Bloquear guias',
        placement: 'MenuBar',
        name: 'Bloquear guias',
    },
    {
        id: 157,
        label: 'Tipo > Texto encadeado > Liberar seleção',
        placement: 'MenuBar',
        name: 'Liberar seleção',
    },
    {
        id: 158,
        label: 'Tipo > Texto encadeado > Remover encadeamento',
        placement: 'MenuBar',
        name: 'Remover encadeamento',
    },
    {
        id: 159,
        label: 'Exibir > Mostrar grade',
        placement: 'MenuBar',
        name: 'Mostrar grade',
    },
    {
        id: 160,
        label: 'Exibir > Encaixar na grade',
        placement: 'MenuBar',
        name: 'Encaixar na grade',
    },
    {
        id: 161,
        label: 'Illustrator > Preferências > Guias e Grade...',
        placement: 'MenuBar',
        name: 'Guias e Grade...',
    },
    {
        id: 162,
        label: 'Objeto > Transformar > Girar...',
        placement: 'MenuBar',
        name: 'Girar...',
    },
    {
        id: 163,
        label: 'Objeto > Transformar > Dimensionar...',
        placement: 'MenuBar',
        name: 'Dimensionar...',
    },
    {
        id: 164,
        label: 'Objeto > Transformar > Refletir...',
        placement: 'MenuBar',
        name: 'Refletir...',
    },
    {
        id: 165,
        label: 'Objeto > Transformar > Inclinar...',
        placement: 'MenuBar',
        name: 'Inclinar...',
    },
    {
        id: 166,
        label: 'Janela > Organizar > Em cascata',
        placement: 'MenuBar',
        name: 'Em cascata',
    },
    {
        id: 168,
        label: 'Janela > Organizar > Dividir em blocos',
        placement: 'MenuBar',
        name: 'Dividir em blocos',
    },
    {
        id: 202,
        label: 'Exibir > Cores de prova',
        placement: 'MenuBar',
        name: 'Cores de prova',
    },
    {
        id: 203,
        label: 'Editar > Atribuir perfil...',
        placement: 'MenuBar',
        name: 'Atribuir perfil...',
    },
    {
        id: 204,
        label: 'Ajuda > Tutoriais...',
        placement: 'MenuBar',
        name: 'Tutoriais...',
    },
    {
        id: 223,
        label: 'Arquivo > Modo de cor do documento > Cor CMYK',
        placement: 'MenuBar',
        name: 'Cor CMYK',
    },
    {
        id: 224,
        label: 'Arquivo > Modo de cor do documento > Cor RGB',
        placement: 'MenuBar',
        name: 'Cor RGB',
    },
    {
        id: 225,
        label: 'Exibir > Configuração de prova > CMYK do documento:',
        placement: 'MenuBar',
        name: 'CMYK do documento:',
    },
    {
        id: 226,
        label: 'Exibir > Configuração de prova > RGB legado da Macintosh RGB (Gama 1.8)',
        placement: 'MenuBar',
        name: 'RGB legado da Macintosh RGB (Gama 1.8)',
    },
    {
        id: 227,
        label: 'Exibir > Configuração de prova > RGB padrão da Internet (sRGB)',
        placement: 'MenuBar',
        name: 'RGB padrão da Internet (sRGB)',
    },
    {
        id: 228,
        label: 'Exibir > Configuração de prova > RGB do monitor',
        placement: 'MenuBar',
        name: 'RGB do monitor',
    },
    {
        id: 229,
        label: 'Tipo > Orientação do tipo > Horizontal',
        placement: 'MenuBar',
        name: 'Horizontal',
    },
    {
        id: 230,
        label: 'Tipo > Orientação do tipo > Vertical',
        placement: 'MenuBar',
        name: 'Vertical',
    },
    {
        id: 232,
        label: 'Ajuda > Informações do sistema...',
        placement: 'MenuBar',
        name: 'Informações do sistema...',
    },
    {
        id: 278,
        label: 'Tipo > Texto legado > Atualizar todo o texto legado',
        placement: 'MenuBar',
        name: 'Atualizar todo o texto legado',
    },
    {
        id: 279,
        label: 'Tipo > Texto legado > Atualizar texto legado selecionado',
        placement: 'MenuBar',
        name: 'Atualizar texto legado selecionado',
    },
    {
        id: 280,
        label: 'Tipo > Texto legado > Ocultar cópias',
        placement: 'MenuBar',
        name: 'Ocultar cópias',
    },
    {
        id: 281,
        label: 'Tipo > Texto legado > Excluir cópias',
        placement: 'MenuBar',
        name: 'Excluir cópias',
    },
    {
        id: 282,
        label: 'Tipo > Texto legado > Selecionar cópias',
        placement: 'MenuBar',
        name: 'Selecionar cópias',
    },
    {
        id: 284,
        label: 'Exibir > Configuração de prova > Personalizar...',
        placement: 'MenuBar',
        name: 'Personalizar...',
    },
    {
        id: 289,
        label: 'Illustrator > Preferências > Seleção e exibição de âncora...',
        placement: 'MenuBar',
        name: 'Seleção e exibição de âncora...',
    },
    {
        id: 292,
        label: 'Objeto > Máscara de recorte > Editar conteúdo',
        placement: 'MenuBar',
        name: 'Editar conteúdo',
    },
    {
        id: 293,
        label: 'Illustrator > Preferências > Interface de usuário...',
        placement: 'MenuBar',
        name: 'Interface de usuário...',
    },
    {
        id: 294,
        label: 'Illustrator > Preferências > Fatias...',
        placement: 'MenuBar',
        name: 'Fatias...',
    },
    {
        id: 295,
        label: 'Janela > Quadro do aplicativo',
        placement: 'MenuBar',
        name: 'Quadro do aplicativo',
    },
    {
        id: 296,
        label: 'Exibir > Configuração de prova > Daltonismo - tipo protanopia',
        placement: 'MenuBar',
        name: 'Daltonismo - tipo protanopia',
    },
    {
        id: 297,
        label: 'Exibir > Configuração de prova > Daltonismo - tipo deuteranopia',
        placement: 'MenuBar',
        name: 'Daltonismo - tipo deuteranopia',
    },
    {
        id: 299,
        label: 'Exibir > Réguas > Mostrar réguas de vídeo',
        placement: 'MenuBar',
        name: 'Mostrar réguas de vídeo',
    },
    {
        id: 301,
        label: 'Janela > Organizar > Flutuar em janela',
        placement: 'MenuBar',
        name: 'Flutuar em janela',
    },
    {
        id: 302,
        label: 'Janela > Organizar > Flutuar tudo em janelas',
        placement: 'MenuBar',
        name: 'Flutuar tudo em janelas',
    },
    {
        id: 303,
        label: 'Janela > Organizar > Consolidar todas as janelas',
        placement: 'MenuBar',
        name: 'Consolidar todas as janelas',
    },
    {
        id: 304,
        label: 'Janela > Barra do aplicativo',
        placement: 'MenuBar',
        name: 'Barra do aplicativo',
    },
    {
        id: 310,
        label: 'Tipo > Tipo em um caminho > Atualizar tipo em um caminho legado',
        placement: 'MenuBar',
        name: 'Atualizar tipo em um caminho legado',
    },
    {
        id: 311,
        label: 'Exibir > Ajustar tudo à janela',
        placement: 'MenuBar',
        name: 'Ajustar tudo à janela',
    },
    {
        id: 315,
        label: 'Editar > Colar no local',
        placement: 'MenuBar',
        name: 'Colar no local',
    },
    {
        id: 316,
        label: 'Editar > Colar em todas as pranchetas',
        placement: 'MenuBar',
        name: 'Colar em todas as pranchetas',
    },
    {
        id: 331,
        label: 'Tipo > Conversão de texto',
        placement: 'MenuBar',
        name: 'Conversão de texto',
    },
    {
        id: 339,
        label: 'Editar > Minhas configurações > Exportar configurações...',
        placement: 'MenuBar',
        name: 'Exportar configurações...',
    },
    {
        id: 340,
        label: 'Editar > Minhas configurações > Importar configurações...',
        placement: 'MenuBar',
        name: 'Importar configurações...',
    },
    {
        id: 347,
        label: 'Exibir > Exibir usando GPU',
        placement: 'MenuBar',
        name: 'Exibir usando GPU',
    },
    {
        id: 351,
        label: 'Arquivo > Exportar seleção...',
        placement: 'MenuBar',
        name: 'Exportar seleção...',
    },
    {
        id: 353,
        label: 'Exibir > Ajustar aos Pixels',
        placement: 'MenuBar',
        name: 'Ajustar aos Pixels',
    },
    {
        id: 354,
        label: 'Arquivo > Exportar > Exportar para telas...',
        placement: 'MenuBar',
        name: 'Exportar para telas...',
    },
    {
        id: 355,
        label: 'Arquivo > Exportar > Exportar como...',
        placement: 'MenuBar',
        name: 'Exportar como...',
    },
    {
        id: 356,
        label: 'Arquivo > Exportar > Salvar para a Web (legado)...',
        placement: 'MenuBar',
        name: 'Salvar para a Web (legado)...',
    },
    {
        id: 368,
        label: 'Tipo > Inserir caractere especial > Símbolos > Marcador',
        placement: 'MenuBar',
        name: 'Marcador',
    },
    {
        id: 369,
        label: 'Tipo > Inserir caractere especial > Símbolos > Símbolo de direito autoral',
        placement: 'MenuBar',
        name: 'Símbolo de direito autoral',
    },
    {
        id: 370,
        label: 'Tipo > Inserir caractere especial > Símbolos > Reticências',
        placement: 'MenuBar',
        name: 'Reticências',
    },
    {
        id: 371,
        label: 'Tipo > Inserir caractere especial > Símbolos > Símbolo de parágrafo',
        placement: 'MenuBar',
        name: 'Símbolo de parágrafo',
    },
    {
        id: 372,
        label: 'Tipo > Inserir caractere especial > Símbolos > Símbolo de marca registrada',
        placement: 'MenuBar',
        name: 'Símbolo de marca registrada',
    },
    {
        id: 373,
        label: 'Tipo > Inserir caractere especial > Símbolos > Símbolo de seção',
        placement: 'MenuBar',
        name: 'Símbolo de seção',
    },
    {
        id: 374,
        label: 'Tipo > Inserir caractere especial > Símbolos > Símbolo de marca comercial',
        placement: 'MenuBar',
        name: 'Símbolo de marca comercial',
    },
    {
        id: 375,
        label: 'Tipo > Inserir caractere especial > Aspas > Aspas duplas à esquerda',
        placement: 'MenuBar',
        name: 'Aspas duplas à esquerda',
    },
    {
        id: 376,
        label: 'Tipo > Inserir caractere especial > Aspas > Aspas duplas à direita',
        placement: 'MenuBar',
        name: 'Aspas duplas à direita',
    },
    {
        id: 377,
        label: 'Tipo > Inserir caractere especial > Aspas > Aspas simples à esquerda',
        placement: 'MenuBar',
        name: 'Aspas simples à esquerda',
    },
    {
        id: 378,
        label: 'Tipo > Inserir caractere especial > Aspas > Aspas simples à direita',
        placement: 'MenuBar',
        name: 'Aspas simples à direita',
    },
    {
        id: 379,
        label: 'Tipo > Inserir caractere especial > Hifens e traços > Traço eme',
        placement: 'MenuBar',
        name: 'Traço eme',
    },
    {
        id: 380,
        label: 'Tipo > Inserir caractere especial > Hifens e traços > Traço ene',
        placement: 'MenuBar',
        name: 'Traço ene',
    },
    {
        id: 381,
        label: 'Tipo > Inserir caractere especial > Hifens e traços > Hífen condicional',
        placement: 'MenuBar',
        name: 'Hífen condicional',
    },
    {
        id: 382,
        label: 'Tipo > Inserir caractere de espaço em branco > Espaço eme',
        placement: 'MenuBar',
        name: 'Espaço eme',
    },
    {
        id: 383,
        label: 'Tipo > Inserir caractere de espaço em branco > Espaço ene',
        placement: 'MenuBar',
        name: 'Espaço ene',
    },
    {
        id: 384,
        label: 'Tipo > Inserir caractere de espaço em branco > Espaço extrafino',
        placement: 'MenuBar',
        name: 'Espaço extrafino',
    },
    {
        id: 385,
        label: 'Tipo > Inserir caractere de espaço em branco > Espaço fino',
        placement: 'MenuBar',
        name: 'Espaço fino',
    },
    {
        id: 386,
        label: 'Tipo > Inserir caractere de quebra > Quebra de linha forçada',
        placement: 'MenuBar',
        name: 'Quebra de linha forçada',
    },
    {
        id: 391,
        label: 'Tipo > Preencher com texto de espaço reservado',
        placement: 'MenuBar',
        name: 'Preencher com texto de espaço reservado',
    },
    {
        id: 393,
        label: 'Objeto > Coletar para exportar > Como Ativo único',
        placement: 'MenuBar',
        name: 'Como Ativo único',
    },
    {
        id: 394,
        label: 'Objeto > Coletar para exportar > Como Vários ativos',
        placement: 'MenuBar',
        name: 'Como Vários ativos',
    },
    {
        id: 396,
        label: 'Exibir > Exibição de corte',
        placement: 'MenuBar',
        name: 'Exibição de corte',
    },
    {
        id: 397,
        label: 'Exibir > Modo de apresentação',
        placement: 'MenuBar',
        name: 'Modo de apresentação',
    },
    {
        id: 404,
        label: 'Exibir > Modo de tela > Modo de tela normal',
        placement: 'MenuBar',
        name: 'Modo de tela normal',
    },
    {
        id: 405,
        label: 'Exibir > Modo de tela > Tela cheia com modo de barra de menu',
        placement: 'MenuBar',
        name: 'Tela cheia com modo de barra de menu',
    },
    {
        id: 406,
        label: 'Exibir > Modo de tela > Modo de tela cheia',
        placement: 'MenuBar',
        name: 'Modo de tela cheia',
    },
    {
        id: 411,
        label: 'Exibir > Ajustar ao glifo',
        placement: 'MenuBar',
        name: 'Ajustar ao glifo',
    },
    {
        id: 415,
        label: 'Exibir > Girar visualização para seleção',
        placement: 'MenuBar',
        name: 'Girar visualização para seleção',
    },
    {
        id: 417,
        label: 'Exibir > Girar visualização > 180',
        placement: 'MenuBar',
        name: '180',
    },
    {
        id: 418,
        label: 'Exibir > Girar visualização > 150',
        placement: 'MenuBar',
        name: '150',
    },
    {
        id: 419,
        label: 'Exibir > Girar visualização > 135',
        placement: 'MenuBar',
        name: '135',
    },
    {
        id: 420,
        label: 'Exibir > Girar visualização > 120',
        placement: 'MenuBar',
        name: '120',
    },
    {
        id: 421,
        label: 'Exibir > Girar visualização > 90',
        placement: 'MenuBar',
        name: '90',
    },
    {
        id: 422,
        label: 'Exibir > Girar visualização > 60',
        placement: 'MenuBar',
        name: '60',
    },
    {
        id: 423,
        label: 'Exibir > Girar visualização > 45',
        placement: 'MenuBar',
        name: '45',
    },
    {
        id: 424,
        label: 'Exibir > Girar visualização > 30',
        placement: 'MenuBar',
        name: '30',
    },
    {
        id: 425,
        label: 'Exibir > Girar visualização > 15',
        placement: 'MenuBar',
        name: '15',
    },
    {
        id: 426,
        label: 'Exibir > Girar visualização > 0',
        placement: 'MenuBar',
        name: '0',
    },
    {
        id: 427,
        label: 'Exibir > Girar visualização > -15',
        placement: 'MenuBar',
        name: '-15',
    },
    {
        id: 428,
        label: 'Exibir > Girar visualização > -30',
        placement: 'MenuBar',
        name: '-30',
    },
    {
        id: 429,
        label: 'Exibir > Girar visualização > -45',
        placement: 'MenuBar',
        name: '-45',
    },
    {
        id: 430,
        label: 'Exibir > Girar visualização > -60',
        placement: 'MenuBar',
        name: '-60',
    },
    {
        id: 431,
        label: 'Exibir > Girar visualização > -90',
        placement: 'MenuBar',
        name: '-90',
    },
    {
        id: 432,
        label: 'Exibir > Girar visualização > -120',
        placement: 'MenuBar',
        name: '-120',
    },
    {
        id: 433,
        label: 'Exibir > Girar visualização > -135',
        placement: 'MenuBar',
        name: '-135',
    },
    {
        id: 434,
        label: 'Exibir > Girar visualização > -150',
        placement: 'MenuBar',
        name: '-150',
    },
    {
        id: 435,
        label: 'Exibir > Girar visualização > -180',
        placement: 'MenuBar',
        name: '-180',
    },
    {
        id: 436,
        label: 'Exibir > Redefinir Girar visualização',
        placement: 'MenuBar',
        name: 'Redefinir Girar visualização',
    },
    {
        id: 437,
        label: 'Editar > Colar sem formatação',
        placement: 'MenuBar',
        name: 'Colar sem formatação',
    },
    {
        id: 438,
        label: 'Ajuda > Novidades...',
        placement: 'MenuBar',
        name: 'Novidades...',
    },
    {
        id: 440,
        label: 'Tipo > Marcadores e numeração > Aplicar marcadores',
        placement: 'MenuBar',
        name: 'Aplicar marcadores',
    },
    {
        id: 441,
        label: 'Tipo > Marcadores e numeração > Aplicar números',
        placement: 'MenuBar',
        name: 'Aplicar números',
    },
    {
        id: 448,
        label: 'Tipo > Marcadores e numeração > Converter em texto',
        placement: 'MenuBar',
        name: 'Converter em texto',
    },
    {
        id: 456,
        label: 'Tipo > Retype',
        placement: 'MenuBar',
        name: 'Retype',
    },
    {
        id: 471,
        label: 'Objeto > Desagrupar tudo',
        placement: 'MenuBar',
        name: 'Desagrupar tudo',
    },
    {
        id: 472,
        label: 'Tipo > Inserir caractere de espaço em branco > Espaço não separável',
        placement: 'MenuBar',
        name: 'Espaço não separável',
    },
    {
        id: 1383427079,
        label: 'Exibir > Réguas > Alterar para réguas da prancheta',
        placement: 'MenuBar',
        name: 'Alterar para réguas da prancheta',
    },
    {
        id: 1633841013,
        label: 'Illustrator > Sobre o Illustrator...',
        placement: 'MenuBar',
        name: 'Sobre o Illustrator...',
    },
    {
        id: 1634233456,
        label: 'Ajuda > Ajuda do Illustrator...',
        placement: 'MenuBar',
        name: 'Ajuda do Illustrator...',
    },
    {
        id: 1634296684,
        label: 'Arquivo > Fechar',
        placement: 'MenuBar',
        name: 'Fechar',
    },
    {
        id: 1668048225,
        label: 'Editar > Limpar',
        placement: 'MenuBar',
        name: 'Limpar',
    },
    {
        id: 1668247673,
        label: 'Editar > Copiar',
        placement: 'MenuBar',
        name: 'Copiar',
    },
    {
        id: 1668641824,
        label: 'Editar > Recortar',
        placement: 'MenuBar',
        name: 'Recortar',
    },
    {
        id: 1751737445,
        label: 'Illustrator > Ocultar o Illustrator',
        placement: 'MenuBar',
        name: 'Ocultar o Illustrator',
    },
    {
        id: 1751737455,
        label: 'Illustrator > Ocultar outros',
        placement: 'MenuBar',
        name: 'Ocultar outros',
    },
    {
        id: 1852143392,
        label: 'Arquivo > Novo...',
        placement: 'MenuBar',
        name: 'Novo...',
    },
    {
        id: 1869636974,
        label: 'Arquivo > Abrir...',
        placement: 'MenuBar',
        name: 'Abrir...',
    },
    {
        id: 1885434740,
        label: 'Editar > Colar',
        placement: 'MenuBar',
        name: 'Colar',
    },
    {
        id: 1886545254,
        label: 'Illustrator > Preferências > Geral...',
        placement: 'MenuBar',
        name: 'Geral...',
    },
    {
        id: 1903520116,
        label: 'Illustrator > Sair do Illustrator',
        placement: 'MenuBar',
        name: 'Sair do Illustrator',
    },
    {
        id: 1919247471,
        label: 'Editar > Refazer',
        placement: 'MenuBar',
        name: 'Refazer',
    },
    {
        id: 1920365172,
        label: 'Arquivo > Reverter',
        placement: 'MenuBar',
        name: 'Reverter',
    },
    {
        id: 1934727834,
        label: 'Selecionar > Tudo na prancheta ativa',
        placement: 'MenuBar',
        name: 'Tudo na prancheta ativa',
    },
    {
        id: 1935764588,
        label: 'Selecionar > Tudo',
        placement: 'MenuBar',
        name: 'Tudo',
    },
    {
        id: 1935767141,
        label: 'Arquivo > Salvar',
        placement: 'MenuBar',
        name: 'Salvar',
    },
    {
        id: 1936220524,
        label: 'Illustrator > Mostrar tudo',
        placement: 'MenuBar',
        name: 'Mostrar tudo',
    },
    {
        id: 1936292352,
        label: 'Tipo > Tamanho > 6 pt',
        placement: 'MenuBar',
        name: '6 pt',
    },
    {
        id: 1936292353,
        label: 'Tipo > Tamanho > 7 pt',
        placement: 'MenuBar',
        name: '7 pt',
    },
    {
        id: 1936292354,
        label: 'Tipo > Tamanho > 8 pt',
        placement: 'MenuBar',
        name: '8 pt',
    },
    {
        id: 1936292355,
        label: 'Tipo > Tamanho > 9 pt',
        placement: 'MenuBar',
        name: '9 pt',
    },
    {
        id: 1936292356,
        label: 'Tipo > Tamanho > 10 pt',
        placement: 'MenuBar',
        name: '10 pt',
    },
    {
        id: 1936292357,
        label: 'Tipo > Tamanho > 11 pt',
        placement: 'MenuBar',
        name: '11 pt',
    },
    {
        id: 1936292358,
        label: 'Tipo > Tamanho > 12 pt',
        placement: 'MenuBar',
        name: '12 pt',
    },
    {
        id: 1936292359,
        label: 'Tipo > Tamanho > 14 pt',
        placement: 'MenuBar',
        name: '14 pt',
    },
    {
        id: 1936292360,
        label: 'Tipo > Tamanho > 18 pt',
        placement: 'MenuBar',
        name: '18 pt',
    },
    {
        id: 1936292361,
        label: 'Tipo > Tamanho > 21 pt',
        placement: 'MenuBar',
        name: '21 pt',
    },
    {
        id: 1936292362,
        label: 'Tipo > Tamanho > 24 pt',
        placement: 'MenuBar',
        name: '24 pt',
    },
    {
        id: 1936292363,
        label: 'Tipo > Tamanho > 36 pt',
        placement: 'MenuBar',
        name: '36 pt',
    },
    {
        id: 1936292364,
        label: 'Tipo > Tamanho > 48 pt',
        placement: 'MenuBar',
        name: '48 pt',
    },
    {
        id: 1936292365,
        label: 'Tipo > Tamanho > 60 pt',
        placement: 'MenuBar',
        name: '60 pt',
    },
    {
        id: 1936292366,
        label: 'Tipo > Tamanho > 72 pt',
        placement: 'MenuBar',
        name: '72 pt',
    },
    {
        id: 1936292367,
        label: 'Tipo > Tamanho > Outro...',
        placement: 'MenuBar',
        name: 'Outro...',
    },
    {
        id: 1937138035,
        label: 'Arquivo > Salvar como...',
        placement: 'MenuBar',
        name: 'Salvar como...',
    },
    {
        id: 1970168943,
        label: 'Editar > Desfazer',
        placement: 'MenuBar',
        name: 'Desfazer',
    },
    {
        id: 2164260867,
        label: 'Ajuda > Gerenciar minha conta...',
        placement: 'MenuBar',
        name: 'Gerenciar minha conta...',
    },
    {
        id: 2164260869,
        label: 'Ajuda > Atualizações...',
        placement: 'MenuBar',
        name: 'Atualizações...',
    },
    {
        id: 2164260870,
        label: 'Efeito > Aplicar último efeito',
        placement: 'MenuBar',
        name: 'Aplicar último efeito',
    },
    {
        id: 2164260871,
        label: 'Efeito > Último efeito',
        placement: 'MenuBar',
        name: 'Último efeito',
    },
    {
        id: 2164260872,
        label: 'Arquivo > Pesquisar Adobe Stock…',
        placement: 'MenuBar',
        name: 'Pesquisar Adobe Stock…',
    },
    {
        id: 2164260873,
        label: 'Arquivo > Inserir...',
        placement: 'MenuBar',
        name: 'Inserir...',
    },
    {
        id: 2164260874,
        label: 'Objeto > Caminho > Remover pontos âncora',
        placement: 'MenuBar',
        name: 'Remover pontos âncora',
    },
    {
        id: 2164260877,
        label: 'Ajuda > Debug > Memory Use Checkpoint',
        placement: 'MenuBar',
        name: 'Memory Use Checkpoint',
    },
    {
        id: 2164260878,
        label: 'Ajuda > Debug > Save Memory Use',
        placement: 'MenuBar',
        name: 'Save Memory Use',
    },
    {
        id: 2164260880,
        label: 'Ajuda > Debug > Progress: Bar Shown',
        placement: 'MenuBar',
        name: 'Progress: Bar Shown',
    },
    {
        id: 2164260881,
        label: 'Ajuda > Debug > Progress: Tight loop for 120 Seconds',
        placement: 'MenuBar',
        name: 'Progress: Tight loop for 120 Seconds',
    },
    {
        id: 2164260882,
        label: 'Ajuda > Debug > Responsive Rate Test',
        placement: 'MenuBar',
        name: 'Responsive Rate Test',
    },
    {
        id: 2164260883,
        label: 'Ajuda > Debug > Test Notification 1',
        placement: 'MenuBar',
        name: 'Test Notification 1',
    },
    {
        id: 2164260884,
        label: 'Ajuda > Debug > Test Notification 2',
        placement: 'MenuBar',
        name: 'Test Notification 2',
    },
    {
        id: 2164260885,
        label: 'Ajuda > Debug > Test Notification 3',
        placement: 'MenuBar',
        name: 'Test Notification 3',
    },
    {
        id: 2164260887,
        label: 'Ajuda > Debug > Count Objects',
        placement: 'MenuBar',
        name: 'Count Objects',
    },
    {
        id: 2164260888,
        label: 'Ajuda > Debug > Object Counts',
        placement: 'MenuBar',
        name: 'Object Counts',
    },
    {
        id: 2164260890,
        label: 'Ajuda > Debug > Track API Refs',
        placement: 'MenuBar',
        name: 'Track API Refs',
    },
    {
        id: 2164260891,
        label: 'Ajuda > Debug > Process Deep Link',
        placement: 'MenuBar',
        name: 'Process Deep Link',
    },
    {
        id: 2164260892,
        label: 'Ajuda > Debug > Start Discover Panel Tour',
        placement: 'MenuBar',
        name: 'Start Discover Panel Tour',
    },
    {
        id: 2164260894,
        label: 'Ajuda > Debug > Enable New Rendering',
        placement: 'MenuBar',
        name: 'Enable New Rendering',
    },
    {
        id: 2164260895,
        label: 'Ajuda > Debug > Enable Rendering Timer',
        placement: 'MenuBar',
        name: 'Enable Rendering Timer',
    },
    {
        id: 2164260896,
        label: 'Ajuda > Debug > Purge Rendering Cache',
        placement: 'MenuBar',
        name: 'Purge Rendering Cache',
    },
    {
        id: 2164260897,
        label: 'Ajuda > Debug > Redraw',
        placement: 'MenuBar',
        name: 'Redraw',
    },
    {
        id: 2164260898,
        label: 'Ajuda > Debug > Dump Application Heap Used',
        placement: 'MenuBar',
        name: 'Dump Application Heap Used',
    },
    {
        id: 2164260899,
        label: 'Ajuda > Debug > Disable Greeking for New Rendering',
        placement: 'MenuBar',
        name: 'Disable Greeking for New Rendering',
    },
    {
        id: 2164260900,
        label: 'Ajuda > Debug > Enable Threaded Rendering',
        placement: 'MenuBar',
        name: 'Enable Threaded Rendering',
    },
    {
        id: 2164260901,
        label: 'Ajuda > Debug > Enable AGM Threading',
        placement: 'MenuBar',
        name: 'Enable AGM Threading',
    },
    {
        id: 2164260902,
        label: 'Ajuda > Debug > Enable AGM Internal Memory Pool',
        placement: 'MenuBar',
        name: 'Enable AGM Internal Memory Pool',
    },
    {
        id: 2164260903,
        label: 'Ajuda > Debug > Enable QuickPort Quartz',
        placement: 'MenuBar',
        name: 'Enable QuickPort Quartz',
    },
    {
        id: 2164260904,
        label: 'Ajuda > Debug > Crash',
        placement: 'MenuBar',
        name: 'Crash',
    },
    {
        id: 2164260906,
        label: 'Ajuda > Debug > Enable PGF Recovery',
        placement: 'MenuBar',
        name: 'Enable PGF Recovery',
    },
    {
        id: 2164260907,
        label: 'Ajuda > Debug > Enable ATE Read Recovery',
        placement: 'MenuBar',
        name: 'Enable ATE Read Recovery',
    },
    {
        id: 2164260908,
        label: 'Ajuda > Debug > Enable ATE Write Recovery',
        placement: 'MenuBar',
        name: 'Enable ATE Write Recovery',
    },
    {
        id: 2164260910,
        label: 'Janela > Informações',
        placement: 'MenuBar',
        name: 'Informações',
    },
    {
        id: 2164260912,
        label: 'Janela > Tipo > Caractere',
        placement: 'MenuBar',
        name: 'Caractere',
    },
    {
        id: 2164260913,
        label: 'Janela > Tipo > Parágrafo',
        placement: 'MenuBar',
        name: 'Parágrafo',
    },
    {
        id: 2164260914,
        label: 'Janela > Tipo > Tabulações',
        placement: 'MenuBar',
        name: 'Tabulações',
    },
    {
        id: 2164260915,
        label: 'Janela > Tipo > OpenType',
        placement: 'MenuBar',
        name: 'OpenType',
    },
    {
        id: 2164260916,
        label: 'Efeito > Efeitos do Photoshop',
        placement: 'MenuBar',
        name: 'Efeitos do Photoshop',
    },
    {
        id: 2164260919,
        label: 'Efeito > Desfoque > Desfoque Inteligente...',
        placement: 'MenuBar',
        name: 'Desfoque Inteligente...',
    },
    {
        id: 2164260920,
        label: 'Efeito > Desfoque > Desfoque Radial...',
        placement: 'MenuBar',
        name: 'Desfoque Radial...',
    },
    {
        id: 2164260922,
        label: 'Efeito > Pixelização > Pontilhar...',
        placement: 'MenuBar',
        name: 'Pontilhar...',
    },
    {
        id: 2164260923,
        label: 'Efeito > Pixelização > Meia-Tinta...',
        placement: 'MenuBar',
        name: 'Meia-Tinta...',
    },
    {
        id: 2164260925,
        label: 'Efeito > Vídeo > Desentrelaçamento...',
        placement: 'MenuBar',
        name: 'Desentrelaçamento...',
    },
    {
        id: 2164260926,
        label: 'Efeito > Pixelização > Cristalizar...',
        placement: 'MenuBar',
        name: 'Cristalizar...',
    },
    {
        id: 2164260927,
        label: 'Efeito > Pixelização > Meio-Tom em Cores...',
        placement: 'MenuBar',
        name: 'Meio-Tom em Cores...',
    },
    {
        id: 2164260928,
        label: 'Exibir > Mostrar espaços de Pintura em tempo real',
        placement: 'MenuBar',
        name: 'Mostrar espaços de Pintura em tempo real',
    },
    {
        id: 2164260931,
        label: 'Objeto > Pintura em tempo real > Criar',
        placement: 'MenuBar',
        name: 'Criar',
    },
    {
        id: 2164260932,
        label: 'Objeto > Pintura em tempo real > Mesclar',
        placement: 'MenuBar',
        name: 'Mesclar',
    },
    {
        id: 2164260933,
        label: 'Objeto > Pintura em tempo real > Liberar',
        placement: 'MenuBar',
        name: 'Liberar',
    },
    {
        id: 2164260935,
        label: 'Objeto > Pintura em tempo real > Opções de espaço...',
        placement: 'MenuBar',
        name: 'Opções de espaço...',
    },
    {
        id: 2164260937,
        label: 'Objeto > Pintura em tempo real > Expandir',
        placement: 'MenuBar',
        name: 'Expandir',
    },
    {
        id: 2164260938,
        label: 'Janela > Bibliotecas',
        placement: 'MenuBar',
        name: 'Bibliotecas',
    },
    {
        id: 2164260940,
        label: 'Janela > Localizar extensões no Exchange...',
        placement: 'MenuBar',
        name: 'Localizar extensões no Exchange...',
    },
    {
        id: 2164260941,
        label: 'Janela > Visualização de separações',
        placement: 'MenuBar',
        name: 'Visualização de separações',
    },
    {
        id: 2164260942,
        label: 'Janela > Links',
        placement: 'MenuBar',
        name: 'Links',
    },
    {
        id: 2164260944,
        label: 'Editar > Editar original',
        placement: 'MenuBar',
        name: 'Editar original',
    },
    {
        id: 2164260946,
        label: 'Janela > Tipo > Estilos de parágrafo',
        placement: 'MenuBar',
        name: 'Estilos de parágrafo',
    },
    {
        id: 2164260947,
        label: 'Janela > Tipo > Estilos de caractere',
        placement: 'MenuBar',
        name: 'Estilos de caractere',
    },
    {
        id: 2164260948,
        label: 'Janela > Pranchetas',
        placement: 'MenuBar',
        name: 'Pranchetas',
    },
    {
        id: 2164260950,
        label: 'Objeto > Pranchetas > Reorganizar& todas as pranchetas',
        placement: 'MenuBar',
        name: 'Reorganizar& todas as pranchetas',
    },
    {
        id: 2164260952,
        label: 'Objeto > Pranchetas > Alinhar aos limites da arte',
        placement: 'MenuBar',
        name: 'Alinhar aos limites da arte',
    },
    {
        id: 2164260953,
        label: 'Objeto > Pranchetas > Alinhar à arte selecionada',
        placement: 'MenuBar',
        name: 'Alinhar à arte selecionada',
    },
    {
        id: 2164260954,
        label: 'Janela > Propriedades',
        placement: 'MenuBar',
        name: 'Propriedades',
    },
    {
        id: 2164260955,
        label: 'Janela > Navegador',
        placement: 'MenuBar',
        name: 'Navegador',
    },
    {
        id: 2164260958,
        label: 'Janela > Espaço de trabalho > Redefinir Getting Started',
        placement: 'MenuBar',
        name: 'Redefinir Getting Started',
    },
    {
        id: 2164260959,
        label: 'Janela > Espaço de trabalho > Novo espaço de trabalho...',
        placement: 'MenuBar',
        name: 'Novo espaço de trabalho...',
    },
    {
        id: 2164260960,
        label: 'Janela > Espaço de trabalho > Gerenciar espaços de trabalho...',
        placement: 'MenuBar',
        name: 'Gerenciar espaços de trabalho...',
    },
    {
        id: 2164260961,
        label: 'Janela > Espaço de trabalho > Getting Started',
        placement: 'MenuBar',
        name: 'Getting Started',
    },
    {
        id: 2164260962,
        label: 'Janela > Espaço de trabalho > Tipografia',
        placement: 'MenuBar',
        name: 'Tipografia',
    },
    {
        id: 2164260963,
        label: 'Janela > Espaço de trabalho > Pintura',
        placement: 'MenuBar',
        name: 'Pintura',
    },
    {
        id: 2164260964,
        label: 'Janela > Espaço de trabalho > Impressão e prova',
        placement: 'MenuBar',
        name: 'Impressão e prova',
    },
    {
        id: 2164260965,
        label: 'Janela > Espaço de trabalho > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164260966,
        label: 'Janela > Espaço de trabalho > Layout',
        placement: 'MenuBar',
        name: 'Layout',
    },
    {
        id: 2164260967,
        label: 'Janela > Espaço de trabalho > Essenciais',
        placement: 'MenuBar',
        name: 'Essenciais',
    },
    {
        id: 2164260968,
        label: 'Janela > Espaço de trabalho > Traçado',
        placement: 'MenuBar',
        name: 'Traçado',
    },
    {
        id: 2164260969,
        label: 'Janela > Espaço de trabalho > Clássicos essenciais',
        placement: 'MenuBar',
        name: 'Clássicos essenciais',
    },
    {
        id: 2164260970,
        label: 'Janela > Espaço de trabalho > Automação',
        placement: 'MenuBar',
        name: 'Automação',
    },
    {
        id: 2164260971,
        label: 'Janela > Camadas',
        placement: 'MenuBar',
        name: 'Camadas',
    },
    {
        id: 2164260974,
        label: 'Editar > Atalhos do teclado...',
        placement: 'MenuBar',
        name: 'Atalhos do teclado...',
    },
    {
        id: 2164260975,
        label: 'Janela > Estilos de gráfico',
        placement: 'MenuBar',
        name: 'Estilos de gráfico',
    },
    {
        id: 2164260976,
        label: 'Janela > Aparência',
        placement: 'MenuBar',
        name: 'Aparência',
    },
    {
        id: 2164260982,
        label: 'Janela > Bibliotecas de estilos de gráfico > Acréscimos para Pincel irregular',
        placement: 'MenuBar',
        name: 'Acréscimos para Pincel irregular',
    },
    {
        id: 2164260983,
        label: 'Janela > Bibliotecas de estilos de gráfico > Acréscimos',
        placement: 'MenuBar',
        name: 'Acréscimos',
    },
    {
        id: 2164260984,
        label: 'Janela > Bibliotecas de estilos de gráfico > Botões e sobreposições',
        placement: 'MenuBar',
        name: 'Botões e sobreposições',
    },
    {
        id: 2164260985,
        label: 'Janela > Bibliotecas de estilos de gráfico > Efeitos 3D',
        placement: 'MenuBar',
        name: 'Efeitos 3D',
    },
    {
        id: 2164260986,
        label: 'Janela > Bibliotecas de estilos de gráfico > Efeitos artísticos',
        placement: 'MenuBar',
        name: 'Efeitos artísticos',
    },
    {
        id: 2164260987,
        label: 'Janela > Bibliotecas de estilos de gráfico > Efeitos de imagem',
        placement: 'MenuBar',
        name: 'Efeitos de imagem',
    },
    {
        id: 2164260988,
        label: 'Janela > Bibliotecas de estilos de gráfico > Efeitos de neon',
        placement: 'MenuBar',
        name: 'Efeitos de neon',
    },
    {
        id: 2164260989,
        label: 'Janela > Bibliotecas de estilos de gráfico > Efeitos de rabiscar',
        placement: 'MenuBar',
        name: 'Efeitos de rabiscar',
    },
    {
        id: 2164260990,
        label: 'Janela > Bibliotecas de estilos de gráfico > Efeitos de texto',
        placement: 'MenuBar',
        name: 'Efeitos de texto',
    },
    {
        id: 2164260991,
        label: 'Janela > Bibliotecas de estilos de gráfico > Estilos com padrão Vonster',
        placement: 'MenuBar',
        name: 'Estilos com padrão Vonster',
    },
    {
        id: 2164260992,
        label: 'Janela > Bibliotecas de estilos de gráfico > Estilos de ornamentação',
        placement: 'MenuBar',
        name: 'Estilos de ornamentação',
    },
    {
        id: 2164260993,
        label: 'Janela > Bibliotecas de estilos de gráfico > Texturas',
        placement: 'MenuBar',
        name: 'Texturas',
    },
    {
        id: 2164260996,
        label: 'Janela > Bibliotecas de estilos de gráfico > Outra biblioteca...',
        placement: 'MenuBar',
        name: 'Outra biblioteca...',
    },
    {
        id: 2164260997,
        label: 'Exibir > Guias inteligentes',
        placement: 'MenuBar',
        name: 'Guias inteligentes',
    },
    {
        id: 2164260998,
        label: 'Janela > Símbolos',
        placement: 'MenuBar',
        name: 'Símbolos',
    },
    {
        id: 2164261000,
        label: 'Janela > Bibliotecas de símbolos > Botões e barras da Web',
        placement: 'MenuBar',
        name: 'Botões e barras da Web',
    },
    {
        id: 2164261001,
        label: 'Janela > Bibliotecas de símbolos > Cabelo e pêlo',
        placement: 'MenuBar',
        name: 'Cabelo e pêlo',
    },
    {
        id: 2164261002,
        label: 'Janela > Bibliotecas de símbolos > Celebração',
        placement: 'MenuBar',
        name: 'Celebração',
    },
    {
        id: 2164261003,
        label: 'Janela > Bibliotecas de símbolos > Ciência maluca',
        placement: 'MenuBar',
        name: 'Ciência maluca',
    },
    {
        id: 2164261004,
        label: 'Janela > Bibliotecas de símbolos > Comunicação',
        placement: 'MenuBar',
        name: 'Comunicação',
    },
    {
        id: 2164261005,
        label: 'Janela > Bibliotecas de símbolos > Elementos de logotipo',
        placement: 'MenuBar',
        name: 'Elementos de logotipo',
    },
    {
        id: 2164261006,
        label: 'Janela > Bibliotecas de símbolos > Fitas ornamentadas',
        placement: 'MenuBar',
        name: 'Fitas ornamentadas',
    },
    {
        id: 2164261007,
        label: 'Janela > Bibliotecas de símbolos > Flores',
        placement: 'MenuBar',
        name: 'Flores',
    },
    {
        id: 2164261008,
        label: 'Janela > Bibliotecas de símbolos > Fluxogramas ornamentados',
        placement: 'MenuBar',
        name: 'Fluxogramas ornamentados',
    },
    {
        id: 2164261009,
        label: 'Janela > Bibliotecas de símbolos > Genealogia',
        placement: 'MenuBar',
        name: 'Genealogia',
    },
    {
        id: 2164261010,
        label: 'Janela > Bibliotecas de símbolos > Gráficos',
        placement: 'MenuBar',
        name: 'Gráficos',
    },
    {
        id: 2164261011,
        label: 'Janela > Bibliotecas de símbolos > Ícones da Web',
        placement: 'MenuBar',
        name: 'Ícones da Web',
    },
    {
        id: 2164261012,
        label: 'Janela > Bibliotecas de símbolos > Mapas',
        placement: 'MenuBar',
        name: 'Mapas',
    },
    {
        id: 2164261013,
        label: 'Janela > Bibliotecas de símbolos > Moda',
        placement: 'MenuBar',
        name: 'Moda',
    },
    {
        id: 2164261014,
        label: 'Janela > Bibliotecas de símbolos > Móvel',
        placement: 'MenuBar',
        name: 'Móvel',
    },
    {
        id: 2164261015,
        label: 'Janela > Bibliotecas de símbolos > Natureza',
        placement: 'MenuBar',
        name: 'Natureza',
    },
    {
        id: 2164261016,
        label: 'Janela > Bibliotecas de símbolos > Organogramas ornamentados',
        placement: 'MenuBar',
        name: 'Organogramas ornamentados',
    },
    {
        id: 2164261017,
        label: 'Janela > Bibliotecas de símbolos > Pacote de vetores de manchas',
        placement: 'MenuBar',
        name: 'Pacote de vetores de manchas',
    },
    {
        id: 2164261018,
        label: 'Janela > Bibliotecas de símbolos > Pacote de vetores de padrão de pontos',
        placement: 'MenuBar',
        name: 'Pacote de vetores de padrão de pontos',
    },
    {
        id: 2164261019,
        label: 'Janela > Bibliotecas de símbolos > Pacote de vetores floridos',
        placement: 'MenuBar',
        name: 'Pacote de vetores floridos',
    },
    {
        id: 2164261020,
        label: 'Janela > Bibliotecas de símbolos > Pacote de vetores régio',
        placement: 'MenuBar',
        name: 'Pacote de vetores régio',
    },
    {
        id: 2164261021,
        label: 'Janela > Bibliotecas de símbolos > Primitivo',
        placement: 'MenuBar',
        name: 'Primitivo',
    },
    {
        id: 2164261022,
        label: 'Janela > Bibliotecas de símbolos > Retrô',
        placement: 'MenuBar',
        name: 'Retrô',
    },
    {
        id: 2164261023,
        label: 'Janela > Bibliotecas de símbolos > Setas',
        placement: 'MenuBar',
        name: 'Setas',
    },
    {
        id: 2164261024,
        label: 'Janela > Bibliotecas de símbolos > Símbolos 3D',
        placement: 'MenuBar',
        name: 'Símbolos 3D',
    },
    {
        id: 2164261025,
        label: 'Janela > Bibliotecas de símbolos > Sushi',
        placement: 'MenuBar',
        name: 'Sushi',
    },
    {
        id: 2164261026,
        label: 'Janela > Bibliotecas de símbolos > Texturas artísticas',
        placement: 'MenuBar',
        name: 'Texturas artísticas',
    },
    {
        id: 2164261027,
        label: 'Janela > Bibliotecas de símbolos > Tiki',
        placement: 'MenuBar',
        name: 'Tiki',
    },
    {
        id: 2164261030,
        label: 'Janela > Bibliotecas de símbolos > Outra biblioteca...',
        placement: 'MenuBar',
        name: 'Outra biblioteca...',
    },
    {
        id: 2164261032,
        label: 'Janela > Informações do documento',
        placement: 'MenuBar',
        name: 'Informações do documento',
    },
    {
        id: 2164261033,
        label: 'Janela > Visualização do nivelador',
        placement: 'MenuBar',
        name: 'Visualização do nivelador',
    },
    {
        id: 2164261034,
        label: 'Janela > Histórico',
        placement: 'MenuBar',
        name: 'Histórico',
    },
    {
        id: 2164261036,
        label: 'Tipo > Glifos',
        placement: 'MenuBar',
        name: 'Glifos',
    },
    {
        id: 2164261037,
        label: 'Janela > Tipo > Glifos',
        placement: 'MenuBar',
        name: 'Glifos',
    },
    {
        id: 2164261038,
        label: 'Janela > Ações',
        placement: 'MenuBar',
        name: 'Ações',
    },
    {
        id: 2164261040,
        label: 'Janela > Cor',
        placement: 'MenuBar',
        name: 'Cor',
    },
    {
        id: 2164261042,
        label: 'Janela > Gradiente',
        placement: 'MenuBar',
        name: 'Gradiente',
    },
    {
        id: 2164261043,
        label: 'Janela > Traçado',
        placement: 'MenuBar',
        name: 'Traçado',
    },
    {
        id: 2164261044,
        label: 'Exibir > Ocultar anotador de gradiente',
        placement: 'MenuBar',
        name: 'Ocultar anotador de gradiente',
    },
    {
        id: 2164261045,
        label: 'Objeto > Caminho > Inverter direção do caminho',
        placement: 'MenuBar',
        name: 'Inverter direção do caminho',
    },
    {
        id: 2164261046,
        label: 'Janela > Transparência',
        placement: 'MenuBar',
        name: 'Transparência',
    },
    {
        id: 2164261047,
        label: 'Exibir > Mostrar grade de transparência',
        placement: 'MenuBar',
        name: 'Mostrar grade de transparência',
    },
    {
        id: 2164261048,
        label: 'Janela > Retype',
        placement: 'MenuBar',
        name: 'Retype',
    },
    {
        id: 2164261050,
        label: 'Objeto > Mesclar > Criar',
        placement: 'MenuBar',
        name: 'Criar',
    },
    {
        id: 2164261051,
        label: 'Objeto > Mesclar > Liberar',
        placement: 'MenuBar',
        name: 'Liberar',
    },
    {
        id: 2164261053,
        label: 'Objeto > Mesclar > Opções de Mesclagem...',
        placement: 'MenuBar',
        name: 'Opções de Mesclagem...',
    },
    {
        id: 2164261055,
        label: 'Objeto > Mesclar > Expandir',
        placement: 'MenuBar',
        name: 'Expandir',
    },
    {
        id: 2164261057,
        label: 'Objeto > Mesclar > Substituir lombada',
        placement: 'MenuBar',
        name: 'Substituir lombada',
    },
    {
        id: 2164261058,
        label: 'Objeto > Mesclar > Inverter lombada',
        placement: 'MenuBar',
        name: 'Inverter lombada',
    },
    {
        id: 2164261059,
        label: 'Objeto > Mesclar > Inverter da frente para trás',
        placement: 'MenuBar',
        name: 'Inverter da frente para trás',
    },
    {
        id: 2164261061,
        label: 'Exibir > Mostrar fatias',
        placement: 'MenuBar',
        name: 'Mostrar fatias',
    },
    {
        id: 2164261062,
        label: 'Exibir > Bloquear fatias',
        placement: 'MenuBar',
        name: 'Bloquear fatias',
    },
    {
        id: 2164261065,
        label: 'Objeto > Fatia > Criar',
        placement: 'MenuBar',
        name: 'Criar',
    },
    {
        id: 2164261066,
        label: 'Objeto > Fatia > Liberar',
        placement: 'MenuBar',
        name: 'Liberar',
    },
    {
        id: 2164261068,
        label: 'Objeto > Fatia > Criar de guias',
        placement: 'MenuBar',
        name: 'Criar de guias',
    },
    {
        id: 2164261069,
        label: 'Objeto > Fatia > Criar de seleção',
        placement: 'MenuBar',
        name: 'Criar de seleção',
    },
    {
        id: 2164261071,
        label: 'Objeto > Fatia > Duplicar fatia',
        placement: 'MenuBar',
        name: 'Duplicar fatia',
    },
    {
        id: 2164261072,
        label: 'Objeto > Fatia > Combinar fatias',
        placement: 'MenuBar',
        name: 'Combinar fatias',
    },
    {
        id: 2164261073,
        label: 'Objeto > Fatia > Dividir fatias...',
        placement: 'MenuBar',
        name: 'Dividir fatias...',
    },
    {
        id: 2164261074,
        label: 'Objeto > Fatia > Excluir tudo',
        placement: 'MenuBar',
        name: 'Excluir tudo',
    },
    {
        id: 2164261076,
        label: 'Objeto > Fatia > Opções de fatia...',
        placement: 'MenuBar',
        name: 'Opções de fatia...',
    },
    {
        id: 2164261078,
        label: 'Objeto > Fatia > Recortar para prancheta',
        placement: 'MenuBar',
        name: 'Recortar para prancheta',
    },
    {
        id: 2164261080,
        label: 'Editar > Editar cores > Mesclar da frente para trás',
        placement: 'MenuBar',
        name: 'Mesclar da frente para trás',
    },
    {
        id: 2164261081,
        label: 'Editar > Editar cores > Mesclar horizontalmente',
        placement: 'MenuBar',
        name: 'Mesclar horizontalmente',
    },
    {
        id: 2164261082,
        label: 'Editar > Editar cores > Mesclar verticalmente',
        placement: 'MenuBar',
        name: 'Mesclar verticalmente',
    },
    {
        id: 2164261083,
        label: 'Editar > Editar cores > Inverter cores',
        placement: 'MenuBar',
        name: 'Inverter cores',
    },
    {
        id: 2164261084,
        label: 'Editar > Editar cores > Converter em escala de cinza',
        placement: 'MenuBar',
        name: 'Converter em escala de cinza',
    },
    {
        id: 2164261085,
        label: 'Editar > Editar cores > Converter em CMYK',
        placement: 'MenuBar',
        name: 'Converter em CMYK',
    },
    {
        id: 2164261086,
        label: 'Editar > Editar cores > Converter em RGB',
        placement: 'MenuBar',
        name: 'Converter em RGB',
    },
    {
        id: 2164261087,
        label: 'Efeito > Efeitos do Illustrator',
        placement: 'MenuBar',
        name: 'Efeitos do Illustrator',
    },
    {
        id: 2164261090,
        label: 'Efeito > Pathfinder > Adicionar',
        placement: 'MenuBar',
        name: 'Adicionar',
    },
    {
        id: 2164261091,
        label: 'Efeito > Pathfinder > Interseção',
        placement: 'MenuBar',
        name: 'Interseção',
    },
    {
        id: 2164261092,
        label: 'Efeito > Pathfinder > Excluir',
        placement: 'MenuBar',
        name: 'Excluir',
    },
    {
        id: 2164261093,
        label: 'Efeito > Pathfinder > Subtrair',
        placement: 'MenuBar',
        name: 'Subtrair',
    },
    {
        id: 2164261094,
        label: 'Efeito > Pathfinder > Menos atrás',
        placement: 'MenuBar',
        name: 'Menos atrás',
    },
    {
        id: 2164261095,
        label: 'Efeito > Pathfinder > Dividir',
        placement: 'MenuBar',
        name: 'Dividir',
    },
    {
        id: 2164261096,
        label: 'Efeito > Pathfinder > Aparar',
        placement: 'MenuBar',
        name: 'Aparar',
    },
    {
        id: 2164261097,
        label: 'Efeito > Pathfinder > Mesclar',
        placement: 'MenuBar',
        name: 'Mesclar',
    },
    {
        id: 2164261098,
        label: 'Efeito > Pathfinder > Corte',
        placement: 'MenuBar',
        name: 'Corte',
    },
    {
        id: 2164261099,
        label: 'Efeito > Pathfinder > Contornar',
        placement: 'MenuBar',
        name: 'Contornar',
    },
    {
        id: 2164261100,
        label: 'Efeito > Pathfinder > Mistura sólida',
        placement: 'MenuBar',
        name: 'Mistura sólida',
    },
    {
        id: 2164261101,
        label: 'Efeito > Pathfinder > Mistura suave...',
        placement: 'MenuBar',
        name: 'Mistura suave...',
    },
    {
        id: 2164261102,
        label: 'Efeito > Pathfinder > Trapping...',
        placement: 'MenuBar',
        name: 'Trapping...',
    },
    {
        id: 2164261103,
        label: 'Selecionar > Selecionar novamente',
        placement: 'MenuBar',
        name: 'Selecionar novamente',
    },
    {
        id: 2164261105,
        label: 'Selecionar > Mesmo(a) > Formas e texto',
        placement: 'MenuBar',
        name: 'Formas e texto',
    },
    {
        id: 2164261106,
        label: 'Selecionar > Mesmo(a) > Texto',
        placement: 'MenuBar',
        name: 'Texto',
    },
    {
        id: 2164261108,
        label: 'Selecionar > Mesmo(a) > Cor do preenchimento',
        placement: 'MenuBar',
        name: 'Cor do preenchimento',
    },
    {
        id: 2164261109,
        label: 'Selecionar > Mesmo(a) > Estilo gráfico',
        placement: 'MenuBar',
        name: 'Estilo gráfico',
    },
    {
        id: 2164261110,
        label: 'Selecionar > Mesmo(a) > Preenchimento e traçado',
        placement: 'MenuBar',
        name: 'Preenchimento e traçado',
    },
    {
        id: 2164261111,
        label: 'Selecionar > Mesmo(a) > Cor do traçado',
        placement: 'MenuBar',
        name: 'Cor do traçado',
    },
    {
        id: 2164261112,
        label: 'Selecionar > Mesmo(a) > Espessura do traçado',
        placement: 'MenuBar',
        name: 'Espessura do traçado',
    },
    {
        id: 2164261113,
        label: 'Selecionar > Mesmo(a) > Modo de mesclagem',
        placement: 'MenuBar',
        name: 'Modo de mesclagem',
    },
    {
        id: 2164261114,
        label: 'Selecionar > Mesmo(a) > Opacidade',
        placement: 'MenuBar',
        name: 'Opacidade',
    },
    {
        id: 2164261115,
        label: 'Selecionar > Mesmo(a) > Forma',
        placement: 'MenuBar',
        name: 'Forma',
    },
    {
        id: 2164261116,
        label: 'Selecionar > Mesmo(a) > Ocorrência de símbolo',
        placement: 'MenuBar',
        name: 'Ocorrência de símbolo',
    },
    {
        id: 2164261117,
        label: 'Selecionar > Mesmo(a) > Série de blocos de link',
        placement: 'MenuBar',
        name: 'Série de blocos de link',
    },
    {
        id: 2164261118,
        label: 'Selecionar > Mesmo(a) > Aparência',
        placement: 'MenuBar',
        name: 'Aparência',
    },
    {
        id: 2164261119,
        label: 'Selecionar > Mesmo(a) > Atributo de aparência',
        placement: 'MenuBar',
        name: 'Atributo de aparência',
    },
    {
        id: 2164261120,
        label: 'Selecionar > Mesmo(a) > Cor de preenchimento de texto',
        placement: 'MenuBar',
        name: 'Cor de preenchimento de texto',
    },
    {
        id: 2164261121,
        label: 'Selecionar > Mesmo(a) > Cor de traçado de texto',
        placement: 'MenuBar',
        name: 'Cor de traçado de texto',
    },
    {
        id: 2164261122,
        label: 'Selecionar > Mesmo(a) > Cor de preenchimento e traçado de texto',
        placement: 'MenuBar',
        name: 'Cor de preenchimento e traçado de texto',
    },
    {
        id: 2164261123,
        label: 'Selecionar > Mesmo(a) > Tamanho da Fonte',
        placement: 'MenuBar',
        name: 'Tamanho da Fonte',
    },
    {
        id: 2164261124,
        label: 'Selecionar > Mesmo(a) > Família de fontes',
        placement: 'MenuBar',
        name: 'Família de fontes',
    },
    {
        id: 2164261125,
        label: 'Selecionar > Mesmo(a) > Família e estilo da fonte',
        placement: 'MenuBar',
        name: 'Família e estilo da fonte',
    },
    {
        id: 2164261126,
        label: 'Selecionar > Mesmo(a) > Família, estilo e tamanho de fonte',
        placement: 'MenuBar',
        name: 'Família, estilo e tamanho de fonte',
    },
    {
        id: 2164261127,
        label: 'Selecionar > Objeto > Pontos isolados',
        placement: 'MenuBar',
        name: 'Pontos isolados',
    },
    {
        id: 2164261129,
        label: 'Selecionar > Objeto > Todos os objetos de texto',
        placement: 'MenuBar',
        name: 'Todos os objetos de texto',
    },
    {
        id: 2164261130,
        label: 'Selecionar > Objeto > Objetos de tipo de ponto',
        placement: 'MenuBar',
        name: 'Objetos de tipo de ponto',
    },
    {
        id: 2164261131,
        label: 'Selecionar > Objeto > Objetos de tipo de área',
        placement: 'MenuBar',
        name: 'Objetos de tipo de área',
    },
    {
        id: 2164261132,
        label: 'Efeito > Marcas de corte',
        placement: 'MenuBar',
        name: 'Marcas de corte',
    },
    {
        id: 2164261133,
        label: 'Objeto > Criar Marcas de aparagem',
        placement: 'MenuBar',
        name: 'Criar Marcas de aparagem',
    },
    {
        id: 2164261134,
        label: 'Objeto > Expandir...',
        placement: 'MenuBar',
        name: 'Expandir...',
    },
    {
        id: 2164261136,
        label: 'Efeito > 3D e Materiais > Extrusão e chanfro...',
        placement: 'MenuBar',
        name: 'Extrusão e chanfro...',
    },
    {
        id: 2164261137,
        label: 'Efeito > 3D e Materiais > Rodear...',
        placement: 'MenuBar',
        name: 'Rodear...',
    },
    {
        id: 2164261138,
        label: 'Efeito > 3D e Materiais > Inflar...',
        placement: 'MenuBar',
        name: 'Inflar...',
    },
    {
        id: 2164261139,
        label: 'Efeito > 3D e Materiais > Girar...',
        placement: 'MenuBar',
        name: 'Girar...',
    },
    {
        id: 2164261140,
        label: 'Efeito > 3D e Materiais > Materiais...',
        placement: 'MenuBar',
        name: 'Materiais...',
    },
    {
        id: 2164261142,
        label: 'Efeito > 3D e Materiais > 3D (clássico) > Extrusão & chanfro (clássico)...',
        placement: 'MenuBar',
        name: 'Extrusão & chanfro (clássico)...',
    },
    {
        id: 2164261143,
        label: 'Efeito > 3D e Materiais > 3D (clássico) > Revolução (clássico)...',
        placement: 'MenuBar',
        name: 'Revolução (clássico)...',
    },
    {
        id: 2164261144,
        label: 'Efeito > 3D e Materiais > 3D (clássico) > Giro (clássico)',
        placement: 'MenuBar',
        name: 'Giro (clássico)',
    },
    {
        id: 2164261145,
        label: 'Janela > Interatividade SVG',
        placement: 'MenuBar',
        name: 'Interatividade SVG',
    },
    {
        id: 2164261146,
        label: 'Illustrator > Preferências > Desempenho...',
        placement: 'MenuBar',
        name: 'Desempenho...',
    },
    {
        id: 2164261147,
        label: 'Illustrator > Preferências > Tratamento de arquivos...',
        placement: 'MenuBar',
        name: 'Tratamento de arquivos...',
    },
    {
        id: 2164261148,
        label: 'Illustrator > Preferências > Tratamento da área de transferência...',
        placement: 'MenuBar',
        name: 'Tratamento da área de transferência...',
    },
    {
        id: 2164261149,
        label: 'Illustrator > Preferências > Aparência do preto...',
        placement: 'MenuBar',
        name: 'Aparência do preto...',
    },
    {
        id: 2164261150,
        label: 'Illustrator > Preferências > Dispositivos...',
        placement: 'MenuBar',
        name: 'Dispositivos...',
    },
    {
        id: 2164261152,
        label: 'Janela > Barras de ferramentas > Básico',
        placement: 'MenuBar',
        name: 'Básico',
    },
    {
        id: 2164261153,
        label: 'Janela > Barras de ferramentas > Avançado',
        placement: 'MenuBar',
        name: 'Avançado',
    },
    {
        id: 2164261154,
        label: 'Janela > Barras de ferramentas > Getting Started',
        placement: 'MenuBar',
        name: 'Getting Started',
    },
    {
        id: 2164261156,
        label: 'Janela > Barras de ferramentas > Nova barra de ferramentas...',
        placement: 'MenuBar',
        name: 'Nova barra de ferramentas...',
    },
    {
        id: 2164261157,
        label: 'Janela > Barras de ferramentas > Gerenciar barras de ferramentas...',
        placement: 'MenuBar',
        name: 'Gerenciar barras de ferramentas...',
    },
    {
        id: 2164261158,
        label: 'Janela > Pincéis',
        placement: 'MenuBar',
        name: 'Pincéis',
    },
    {
        id: 2164261159,
        label: 'Selecionar > Objeto > Traçados de pincel',
        placement: 'MenuBar',
        name: 'Traçados de pincel',
    },
    {
        id: 2164261162,
        label: 'Janela > Bibliotecas de pincéis > Artístico > Aquarela_artística',
        placement: 'MenuBar',
        name: 'Aquarela_artística',
    },
    {
        id: 2164261163,
        label: 'Janela > Bibliotecas de pincéis > Artístico > Caligrafia_artística',
        placement: 'MenuBar',
        name: 'Caligrafia_artística',
    },
    {
        id: 2164261164,
        label: 'Janela > Bibliotecas de pincéis > Artístico > CanetaRolagem_artística',
        placement: 'MenuBar',
        name: 'CanetaRolagem_artística',
    },
    {
        id: 2164261165,
        label: 'Janela > Bibliotecas de pincéis > Artístico > LápisCarvãoGiz_artístico',
        placement: 'MenuBar',
        name: 'LápisCarvãoGiz_artístico',
    },
    {
        id: 2164261166,
        label: 'Janela > Bibliotecas de pincéis > Artístico > Pincel_artístico',
        placement: 'MenuBar',
        name: 'Pincel_artístico',
    },
    {
        id: 2164261167,
        label: 'Janela > Bibliotecas de pincéis > Artístico > Tinta_artística',
        placement: 'MenuBar',
        name: 'Tinta_artística',
    },
    {
        id: 2164261169,
        label: 'Janela > Bibliotecas de pincéis > Bordas > Bordas_decorativas',
        placement: 'MenuBar',
        name: 'Bordas_decorativas',
    },
    {
        id: 2164261170,
        label: 'Janela > Bibliotecas de pincéis > Bordas > Bordas_geométricas',
        placement: 'MenuBar',
        name: 'Bordas_geométricas',
    },
    {
        id: 2164261171,
        label: 'Janela > Bibliotecas de pincéis > Bordas > Bordas_primitivas',
        placement: 'MenuBar',
        name: 'Bordas_primitivas',
    },
    {
        id: 2164261172,
        label: 'Janela > Bibliotecas de pincéis > Bordas > Bordas_tracejadas',
        placement: 'MenuBar',
        name: 'Bordas_tracejadas',
    },
    {
        id: 2164261173,
        label: 'Janela > Bibliotecas de pincéis > Bordas > Decoração_de_bordas',
        placement: 'MenuBar',
        name: 'Decoração_de_bordas',
    },
    {
        id: 2164261174,
        label: 'Janela > Bibliotecas de pincéis > Bordas > Linhas_de_bordas',
        placement: 'MenuBar',
        name: 'Linhas_de_bordas',
    },
    {
        id: 2164261175,
        label: 'Janela > Bibliotecas de pincéis > Bordas > Quadros_de_bordas',
        placement: 'MenuBar',
        name: 'Quadros_de_bordas',
    },
    {
        id: 2164261177,
        label: 'Janela > Bibliotecas de pincéis > Decorativo > Conjunto de caracóis elegantes e pincéis florais',
        placement: 'MenuBar',
        name: 'Conjunto de caracóis elegantes e pincéis florais',
    },
    {
        id: 2164261178,
        label: 'Janela > Bibliotecas de pincéis > Decorativo > Dispersão_decorativa',
        placement: 'MenuBar',
        name: 'Dispersão_decorativa',
    },
    {
        id: 2164261179,
        label: 'Janela > Bibliotecas de pincéis > Decorativo > Divisores de texto_decorativos',
        placement: 'MenuBar',
        name: 'Divisores de texto_decorativos',
    },
    {
        id: 2164261180,
        label: 'Janela > Bibliotecas de pincéis > Decorativo > Selos e pôsteres_decorativos',
        placement: 'MenuBar',
        name: 'Selos e pôsteres_decorativos',
    },
    {
        id: 2164261182,
        label: 'Janela > Bibliotecas de pincéis > Pacotes de vetores > Pacote de vetores de pincéis à mão',
        placement: 'MenuBar',
        name: 'Pacote de vetores de pincéis à mão',
    },
    {
        id: 2164261183,
        label: 'Janela > Bibliotecas de pincéis > Pacotes de vetores > Pacote de vetores de pincéis desordenados',
        placement: 'MenuBar',
        name: 'Pacote de vetores de pincéis desordenados',
    },
    {
        id: 2164261185,
        label: 'Janela > Bibliotecas de pincéis > Pincel de cerda > Biblioteca Bristle Brush',
        placement: 'MenuBar',
        name: 'Biblioteca Bristle Brush',
    },
    {
        id: 2164261187,
        label: 'Janela > Bibliotecas de pincéis > Pincel de imagem > Biblioteca de pincéis de imagem',
        placement: 'MenuBar',
        name: 'Biblioteca de pincéis de imagem',
    },
    {
        id: 2164261189,
        label: 'Janela > Bibliotecas de pincéis > Pincéis 6D Wacom > Pincéis canetas de arte 6d',
        placement: 'MenuBar',
        name: 'Pincéis canetas de arte 6d',
    },
    {
        id: 2164261191,
        label: 'Janela > Bibliotecas de pincéis > Setas > Padrões de setas',
        placement: 'MenuBar',
        name: 'Padrões de setas',
    },
    {
        id: 2164261192,
        label: 'Janela > Bibliotecas de pincéis > Setas > Setas_especiais',
        placement: 'MenuBar',
        name: 'Setas_especiais',
    },
    {
        id: 2164261193,
        label: 'Janela > Bibliotecas de pincéis > Setas > Setas_padrão',
        placement: 'MenuBar',
        name: 'Setas_padrão',
    },
    {
        id: 2164261196,
        label: 'Janela > Bibliotecas de pincéis > Outra biblioteca...',
        placement: 'MenuBar',
        name: 'Outra biblioteca...',
    },
    {
        id: 2164261197,
        label: 'Janela > Pathfinder',
        placement: 'MenuBar',
        name: 'Pathfinder',
    },
    {
        id: 2164261198,
        label: 'Janela > Variáveis',
        placement: 'MenuBar',
        name: 'Variáveis',
    },
    {
        id: 2164261200,
        label: 'Janela > Varinha mágica',
        placement: 'MenuBar',
        name: 'Varinha mágica',
    },
    {
        id: 2164261201,
        label: 'Objeto > Caminho > Dividir objetos abaixo',
        placement: 'MenuBar',
        name: 'Dividir objetos abaixo',
    },
    {
        id: 2164261202,
        label: 'Selecionar > Objeto > Traçados do pincel de cerdas',
        placement: 'MenuBar',
        name: 'Traçados do pincel de cerdas',
    },
    {
        id: 2164261205,
        label: 'Objeto > Transformar > Redefinir caixa delimitadora',
        placement: 'MenuBar',
        name: 'Redefinir caixa delimitadora',
    },
    {
        id: 2164261206,
        label: 'Exibir > Ocultar caixa delimitadora',
        placement: 'MenuBar',
        name: 'Ocultar caixa delimitadora',
    },
    {
        id: 2164261207,
        label: 'Objeto > Caminho > Simplificar...',
        placement: 'MenuBar',
        name: 'Simplificar...',
    },
    {
        id: 2164261208,
        label: 'Objeto > Caminho > Suavizar...',
        placement: 'MenuBar',
        name: 'Suavizar...',
    },
    {
        id: 2164261209,
        label: 'Janela > Amostras',
        placement: 'MenuBar',
        name: 'Amostras',
    },
    {
        id: 2164261212,
        label: 'Janela > Opções de padrão',
        placement: 'MenuBar',
        name: 'Opções de padrão',
    },
    {
        id: 2164261213,
        label: 'Janela > Gerar padrões (Beta)',
        placement: 'MenuBar',
        name: 'Gerar padrões (Beta)',
    },
    {
        id: 2164261215,
        label: 'Objeto > Padrão > Criar',
        placement: 'MenuBar',
        name: 'Criar',
    },
    {
        id: 2164261217,
        label: 'Objeto > Padrão > Editar padrão',
        placement: 'MenuBar',
        name: 'Editar padrão',
    },
    {
        id: 2164261218,
        label: 'Objeto > Padrão > Cor do limite de bloco gráfico....',
        placement: 'MenuBar',
        name: 'Cor do limite de bloco gráfico....',
    },
    {
        id: 2164261220,
        label: 'Objeto > Padrão > Gerar padrões (Beta)',
        placement: 'MenuBar',
        name: 'Gerar padrões (Beta)',
    },
    {
        id: 2164261222,
        label: 'Janela > Biblioteca de amostras > Amostras padrão > Dispositivos',
        placement: 'MenuBar',
        name: 'Dispositivos',
    },
    {
        id: 2164261223,
        label: 'Janela > Biblioteca de amostras > Amostras padrão > Impressão',
        placement: 'MenuBar',
        name: 'Impressão',
    },
    {
        id: 2164261224,
        label: 'Janela > Biblioteca de amostras > Amostras padrão > RGB básico',
        placement: 'MenuBar',
        name: 'RGB básico',
    },
    {
        id: 2164261225,
        label: 'Janela > Biblioteca de amostras > Amostras padrão > Vídeo e filme',
        placement: 'MenuBar',
        name: 'Vídeo e filme',
    },
    {
        id: 2164261226,
        label: 'Janela > Biblioteca de amostras > Amostras padrão > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164261227,
        label: 'Janela > Biblioteca de amostras > Celebração',
        placement: 'MenuBar',
        name: 'Celebração',
    },
    {
        id: 2164261229,
        label: 'Janela > Biblioteca de amostras > Científico > Análogo',
        placement: 'MenuBar',
        name: 'Análogo',
    },
    {
        id: 2164261230,
        label: 'Janela > Biblioteca de amostras > Científico > Complementar',
        placement: 'MenuBar',
        name: 'Complementar',
    },
    {
        id: 2164261231,
        label: 'Janela > Biblioteca de amostras > Científico > Dividir complementar',
        placement: 'MenuBar',
        name: 'Dividir complementar',
    },
    {
        id: 2164261232,
        label: 'Janela > Biblioteca de amostras > Científico > Tétrade',
        placement: 'MenuBar',
        name: 'Tétrade',
    },
    {
        id: 2164261233,
        label: 'Janela > Biblioteca de amostras > Científico > Tríade',
        placement: 'MenuBar',
        name: 'Tríade',
    },
    {
        id: 2164261235,
        label: 'Janela > Biblioteca de amostras > Comidas > Bebidas',
        placement: 'MenuBar',
        name: 'Bebidas',
    },
    {
        id: 2164261236,
        label: 'Janela > Biblioteca de amostras > Comidas > Doces',
        placement: 'MenuBar',
        name: 'Doces',
    },
    {
        id: 2164261237,
        label: 'Janela > Biblioteca de amostras > Comidas > Fruta',
        placement: 'MenuBar',
        name: 'Fruta',
    },
    {
        id: 2164261238,
        label: 'Janela > Biblioteca de amostras > Comidas > Sorvete',
        placement: 'MenuBar',
        name: 'Sorvete',
    },
    {
        id: 2164261239,
        label: 'Janela > Biblioteca de amostras > Comidas > Vegetais',
        placement: 'MenuBar',
        name: 'Vegetais',
    },
    {
        id: 2164261240,
        label: 'Janela > Biblioteca de amostras > Crianças',
        placement: 'MenuBar',
        name: 'Crianças',
    },
    {
        id: 2164261241,
        label: 'Janela > Biblioteca de amostras > Empresarial',
        placement: 'MenuBar',
        name: 'Empresarial',
    },
    {
        id: 2164261243,
        label: 'Janela > Biblioteca de amostras > Gradientes > Água',
        placement: 'MenuBar',
        name: 'Água',
    },
    {
        id: 2164261244,
        label: 'Janela > Biblioteca de amostras > Gradientes > Brilhos',
        placement: 'MenuBar',
        name: 'Brilhos',
    },
    {
        id: 2164261245,
        label: 'Janela > Biblioteca de amostras > Gradientes > Céu',
        placement: 'MenuBar',
        name: 'Céu',
    },
    {
        id: 2164261246,
        label: 'Janela > Biblioteca de amostras > Gradientes > Combinações de cores',
        placement: 'MenuBar',
        name: 'Combinações de cores',
    },
    {
        id: 2164261247,
        label: 'Janela > Biblioteca de amostras > Gradientes > Esmaecer',
        placement: 'MenuBar',
        name: 'Esmaecer',
    },
    {
        id: 2164261248,
        label: 'Janela > Biblioteca de amostras > Gradientes > Espectros',
        placement: 'MenuBar',
        name: 'Espectros',
    },
    {
        id: 2164261249,
        label: 'Janela > Biblioteca de amostras > Gradientes > Estações do ano',
        placement: 'MenuBar',
        name: 'Estações do ano',
    },
    {
        id: 2164261250,
        label: 'Janela > Biblioteca de amostras > Gradientes > Frutas e vegetais',
        placement: 'MenuBar',
        name: 'Frutas e vegetais',
    },
    {
        id: 2164261251,
        label: 'Janela > Biblioteca de amostras > Gradientes > Harmonias de cores',
        placement: 'MenuBar',
        name: 'Harmonias de cores',
    },
    {
        id: 2164261252,
        label: 'Janela > Biblioteca de amostras > Gradientes > Madeira',
        placement: 'MenuBar',
        name: 'Madeira',
    },
    {
        id: 2164261253,
        label: 'Janela > Biblioteca de amostras > Gradientes > Metais',
        placement: 'MenuBar',
        name: 'Metais',
    },
    {
        id: 2164261254,
        label: 'Janela > Biblioteca de amostras > Gradientes > Neutros',
        placement: 'MenuBar',
        name: 'Neutros',
    },
    {
        id: 2164261255,
        label: 'Janela > Biblioteca de amostras > Gradientes > Pastéis',
        placement: 'MenuBar',
        name: 'Pastéis',
    },
    {
        id: 2164261256,
        label: 'Janela > Biblioteca de amostras > Gradientes > Pedra e tijolo',
        placement: 'MenuBar',
        name: 'Pedra e tijolo',
    },
    {
        id: 2164261257,
        label: 'Janela > Biblioteca de amostras > Gradientes > Pedras preciosas e jóias',
        placement: 'MenuBar',
        name: 'Pedras preciosas e jóias',
    },
    {
        id: 2164261258,
        label: 'Janela > Biblioteca de amostras > Gradientes > Radial simples',
        placement: 'MenuBar',
        name: 'Radial simples',
    },
    {
        id: 2164261259,
        label: 'Janela > Biblioteca de amostras > Gradientes > Tons de pele',
        placement: 'MenuBar',
        name: 'Tons de pele',
    },
    {
        id: 2164261260,
        label: 'Janela > Biblioteca de amostras > Gradientes > Tons e graduações de cor',
        placement: 'MenuBar',
        name: 'Tons e graduações de cor',
    },
    {
        id: 2164261261,
        label: 'Janela > Biblioteca de amostras > Gradientes > Tons terrestre',
        placement: 'MenuBar',
        name: 'Tons terrestre',
    },
    {
        id: 2164261262,
        label: 'Janela > Biblioteca de amostras > Gradientes > Vegetação',
        placement: 'MenuBar',
        name: 'Vegetação',
    },
    {
        id: 2164261263,
        label: 'Janela > Biblioteca de amostras > Gradientes > Vinhetas',
        placement: 'MenuBar',
        name: 'Vinhetas',
    },
    {
        id: 2164261265,
        label: 'Janela > Biblioteca de amostras > Histórico artístico > Antigüidade',
        placement: 'MenuBar',
        name: 'Antigüidade',
    },
    {
        id: 2164261266,
        label: 'Janela > Biblioteca de amostras > Histórico artístico > Arte Pop',
        placement: 'MenuBar',
        name: 'Arte Pop',
    },
    {
        id: 2164261267,
        label: 'Janela > Biblioteca de amostras > Histórico artístico > Arte pôster russo',
        placement: 'MenuBar',
        name: 'Arte pôster russo',
    },
    {
        id: 2164261268,
        label: 'Janela > Biblioteca de amostras > Histórico artístico > Barroco',
        placement: 'MenuBar',
        name: 'Barroco',
    },
    {
        id: 2164261269,
        label: 'Janela > Biblioteca de amostras > Histórico artístico > Idade Média',
        placement: 'MenuBar',
        name: 'Idade Média',
    },
    {
        id: 2164261270,
        label: 'Janela > Biblioteca de amostras > Histórico artístico > Impressionismo',
        placement: 'MenuBar',
        name: 'Impressionismo',
    },
    {
        id: 2164261271,
        label: 'Janela > Biblioteca de amostras > Histórico artístico > Pré-histórico',
        placement: 'MenuBar',
        name: 'Pré-histórico',
    },
    {
        id: 2164261272,
        label: 'Janela > Biblioteca de amostras > Histórico artístico > Renascença',
        placement: 'MenuBar',
        name: 'Renascença',
    },
    {
        id: 2164261274,
        label: 'Janela > Biblioteca de amostras > Livros coloridos > ANPA Color',
        placement: 'MenuBar',
        name: 'ANPA Color',
    },
    {
        id: 2164261275,
        label: 'Janela > Biblioteca de amostras > Livros coloridos > DIC Color Guide',
        placement: 'MenuBar',
        name: 'DIC Color Guide',
    },
    {
        id: 2164261276,
        label: 'Janela > Biblioteca de amostras > Livros coloridos > FOCOLTONE',
        placement: 'MenuBar',
        name: 'FOCOLTONE',
    },
    {
        id: 2164261277,
        label: 'Janela > Biblioteca de amostras > Livros coloridos > HKS E Process',
        placement: 'MenuBar',
        name: 'HKS E Process',
    },
    {
        id: 2164261278,
        label: 'Janela > Biblioteca de amostras > Livros coloridos > HKS E',
        placement: 'MenuBar',
        name: 'HKS E',
    },
    {
        id: 2164261279,
        label: 'Janela > Biblioteca de amostras > Livros coloridos > HKS K Process',
        placement: 'MenuBar',
        name: 'HKS K Process',
    },
    {
        id: 2164261280,
        label: 'Janela > Biblioteca de amostras > Livros coloridos > HKS K',
        placement: 'MenuBar',
        name: 'HKS K',
    },
    {
        id: 2164261281,
        label: 'Janela > Biblioteca de amostras > Livros coloridos > HKS N Process',
        placement: 'MenuBar',
        name: 'HKS N Process',
    },
    {
        id: 2164261282,
        label: 'Janela > Biblioteca de amostras > Livros coloridos > HKS N',
        placement: 'MenuBar',
        name: 'HKS N',
    },
    {
        id: 2164261283,
        label: 'Janela > Biblioteca de amostras > Livros coloridos > HKS Z Process',
        placement: 'MenuBar',
        name: 'HKS Z Process',
    },
    {
        id: 2164261284,
        label: 'Janela > Biblioteca de amostras > Livros coloridos > HKS Z',
        placement: 'MenuBar',
        name: 'HKS Z',
    },
    {
        id: 2164261285,
        label: 'Janela > Biblioteca de amostras > Livros coloridos > TOYO 94 COLOR FINDER',
        placement: 'MenuBar',
        name: 'TOYO 94 COLOR FINDER',
    },
    {
        id: 2164261286,
        label: 'Janela > Biblioteca de amostras > Livros coloridos > TOYO COLOR FINDER',
        placement: 'MenuBar',
        name: 'TOYO COLOR FINDER',
    },
    {
        id: 2164261287,
        label: 'Janela > Biblioteca de amostras > Livros coloridos > TRUMATCH',
        placement: 'MenuBar',
        name: 'TRUMATCH',
    },
    {
        id: 2164261288,
        label: 'Janela > Biblioteca de amostras > Metal',
        placement: 'MenuBar',
        name: 'Metal',
    },
    {
        id: 2164261290,
        label: 'Janela > Biblioteca de amostras > Natureza > Estações do ano',
        placement: 'MenuBar',
        name: 'Estações do ano',
    },
    {
        id: 2164261291,
        label: 'Janela > Biblioteca de amostras > Natureza > Flores',
        placement: 'MenuBar',
        name: 'Flores',
    },
    {
        id: 2164261292,
        label: 'Janela > Biblioteca de amostras > Natureza > Paisagem',
        placement: 'MenuBar',
        name: 'Paisagem',
    },
    {
        id: 2164261293,
        label: 'Janela > Biblioteca de amostras > Natureza > Pedra e tijolo',
        placement: 'MenuBar',
        name: 'Pedra e tijolo',
    },
    {
        id: 2164261294,
        label: 'Janela > Biblioteca de amostras > Natureza > Praia',
        placement: 'MenuBar',
        name: 'Praia',
    },
    {
        id: 2164261295,
        label: 'Janela > Biblioteca de amostras > Natureza > Vegetais',
        placement: 'MenuBar',
        name: 'Vegetais',
    },
    {
        id: 2164261296,
        label: 'Janela > Biblioteca de amostras > Neutro',
        placement: 'MenuBar',
        name: 'Neutro',
    },
    {
        id: 2164261299,
        label: 'Janela > Biblioteca de amostras > Padrões > Decorativo > Decorative_Retro',
        placement: 'MenuBar',
        name: 'Decorative_Retro',
    },
    {
        id: 2164261300,
        label: 'Janela > Biblioteca de amostras > Padrões > Decorativo > Decorative_Tiki',
        placement: 'MenuBar',
        name: 'Decorative_Tiki',
    },
    {
        id: 2164261301,
        label: 'Janela > Biblioteca de amostras > Padrões > Decorativo > Legados decorativos',
        placement: 'MenuBar',
        name: 'Legados decorativos',
    },
    {
        id: 2164261302,
        label: 'Janela > Biblioteca de amostras > Padrões > Decorativo > Padrões Vonster',
        placement: 'MenuBar',
        name: 'Padrões Vonster',
    },
    {
        id: 2164261304,
        label: 'Janela > Biblioteca de amostras > Padrões > Gráficos básicos > Linhas de_gráficos básicas',
        placement: 'MenuBar',
        name: 'Linhas de_gráficos básicas',
    },
    {
        id: 2164261305,
        label: 'Janela > Biblioteca de amostras > Padrões > Gráficos básicos > Pontos de_gráficos básicos',
        placement: 'MenuBar',
        name: 'Pontos de_gráficos básicos',
    },
    {
        id: 2164261306,
        label: 'Janela > Biblioteca de amostras > Padrões > Gráficos básicos > Texturas de_gráficos básicas',
        placement: 'MenuBar',
        name: 'Texturas de_gráficos básicas',
    },
    {
        id: 2164261308,
        label: 'Janela > Biblioteca de amostras > Padrões > Natureza > Peles de animais da_natureza',
        placement: 'MenuBar',
        name: 'Peles de animais da_natureza',
    },
    {
        id: 2164261309,
        label: 'Janela > Biblioteca de amostras > Padrões > Natureza > Vegetação da_natureza',
        placement: 'MenuBar',
        name: 'Vegetação da_natureza',
    },
    {
        id: 2164261311,
        label: 'Janela > Biblioteca de amostras > Propriedades de cor > Brilho',
        placement: 'MenuBar',
        name: 'Brilho',
    },
    {
        id: 2164261312,
        label: 'Janela > Biblioteca de amostras > Propriedades de cor > Escuro',
        placement: 'MenuBar',
        name: 'Escuro',
    },
    {
        id: 2164261313,
        label: 'Janela > Biblioteca de amostras > Propriedades de cor > Frio',
        placement: 'MenuBar',
        name: 'Frio',
    },
    {
        id: 2164261314,
        label: 'Janela > Biblioteca de amostras > Propriedades de cor > Luz',
        placement: 'MenuBar',
        name: 'Luz',
    },
    {
        id: 2164261315,
        label: 'Janela > Biblioteca de amostras > Propriedades de cor > Não saturado',
        placement: 'MenuBar',
        name: 'Não saturado',
    },
    {
        id: 2164261316,
        label: 'Janela > Biblioteca de amostras > Propriedades de cor > Quente',
        placement: 'MenuBar',
        name: 'Quente',
    },
    {
        id: 2164261317,
        label: 'Janela > Biblioteca de amostras > Propriedades de cor > Saturado',
        placement: 'MenuBar',
        name: 'Saturado',
    },
    {
        id: 2164261318,
        label: 'Janela > Biblioteca de amostras > Propriedades de cor > Suave',
        placement: 'MenuBar',
        name: 'Suave',
    },
    {
        id: 2164261319,
        label: 'Janela > Biblioteca de amostras > Sistema (Macintosh)',
        placement: 'MenuBar',
        name: 'Sistema (Macintosh)',
    },
    {
        id: 2164261320,
        label: 'Janela > Biblioteca de amostras > Sistema (Windows)',
        placement: 'MenuBar',
        name: 'Sistema (Windows)',
    },
    {
        id: 2164261321,
        label: 'Janela > Biblioteca de amostras > Têxteis',
        placement: 'MenuBar',
        name: 'Têxteis',
    },
    {
        id: 2164261322,
        label: 'Janela > Biblioteca de amostras > Tom terrestre',
        placement: 'MenuBar',
        name: 'Tom terrestre',
    },
    {
        id: 2164261323,
        label: 'Janela > Biblioteca de amostras > Tons de pele',
        placement: 'MenuBar',
        name: 'Tons de pele',
    },
    {
        id: 2164261324,
        label: 'Janela > Biblioteca de amostras > VisiBone2',
        placement: 'MenuBar',
        name: 'VisiBone2',
    },
    {
        id: 2164261325,
        label: 'Janela > Biblioteca de amostras > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164261328,
        label: 'Janela > Biblioteca de amostras > Outra biblioteca...',
        placement: 'MenuBar',
        name: 'Outra biblioteca...',
    },
    {
        id: 2164261329,
        label: 'Janela > Guia de cores',
        placement: 'MenuBar',
        name: 'Guia de cores',
    },
    {
        id: 2164261330,
        label: 'Editar > Editar cores > Recolorir arte...',
        placement: 'MenuBar',
        name: 'Recolorir arte...',
    },
    {
        id: 2164261333,
        label: 'Editar > Editar cores > Recoloração generativa',
        placement: 'MenuBar',
        name: 'Recoloração generativa',
    },
    {
        id: 2164261335,
        label: 'Editar > Editar cores > Recolorir com predefinição > Biblioteca de cores...',
        placement: 'MenuBar',
        name: 'Biblioteca de cores...',
    },
    {
        id: 2164261336,
        label: 'Editar > Editar cores > Recolorir com predefinição > Uma cor',
        placement: 'MenuBar',
        name: 'Uma cor',
    },
    {
        id: 2164261337,
        label: 'Editar > Editar cores > Recolorir com predefinição > Duas Cores',
        placement: 'MenuBar',
        name: 'Duas Cores',
    },
    {
        id: 2164261338,
        label: 'Editar > Editar cores > Recolorir com predefinição > Três cores',
        placement: 'MenuBar',
        name: 'Três cores',
    },
    {
        id: 2164261339,
        label: 'Editar > Editar cores > Recolorir com predefinição > Harmonia de cores',
        placement: 'MenuBar',
        name: 'Harmonia de cores',
    },
    {
        id: 2164261340,
        label: 'Janela > Controle',
        placement: 'MenuBar',
        name: 'Controle',
    },
    {
        id: 2164261341,
        label: 'Janela > Barra de tarefas contextual',
        placement: 'MenuBar',
        name: 'Barra de tarefas contextual',
    },
    {
        id: 2164261343,
        label: 'Objeto > Entrelaçar > Criar',
        placement: 'MenuBar',
        name: 'Criar',
    },
    {
        id: 2164261344,
        label: 'Objeto > Entrelaçar > Liberar',
        placement: 'MenuBar',
        name: 'Liberar',
    },
    {
        id: 2164261345,
        label: 'Objeto > Entrelaçar > Editar',
        placement: 'MenuBar',
        name: 'Editar',
    },
    {
        id: 2164261346,
        label: 'Janela > Alinhar',
        placement: 'MenuBar',
        name: 'Alinhar',
    },
    {
        id: 2164261348,
        label: 'Objeto > Alinhar > Alinhamento horizontal à esquerda',
        placement: 'MenuBar',
        name: 'Alinhamento horizontal à esquerda',
    },
    {
        id: 2164261349,
        label: 'Objeto > Alinhar > Alinhamento horizontal centralizado',
        placement: 'MenuBar',
        name: 'Alinhamento horizontal centralizado',
    },
    {
        id: 2164261350,
        label: 'Objeto > Alinhar > Alinhamento horizontal à direita',
        placement: 'MenuBar',
        name: 'Alinhamento horizontal à direita',
    },
    {
        id: 2164261351,
        label: 'Objeto > Alinhar > Alinhamento vertical superior',
        placement: 'MenuBar',
        name: 'Alinhamento vertical superior',
    },
    {
        id: 2164261352,
        label: 'Objeto > Alinhar > Alinhamento vertical centralizado',
        placement: 'MenuBar',
        name: 'Alinhamento vertical centralizado',
    },
    {
        id: 2164261353,
        label: 'Objeto > Alinhar > Alinhamento vertical inferior',
        placement: 'MenuBar',
        name: 'Alinhamento vertical inferior',
    },
    {
        id: 2164261355,
        label: 'Objeto > Distribuir > Distribuição vertical superior',
        placement: 'MenuBar',
        name: 'Distribuição vertical superior',
    },
    {
        id: 2164261356,
        label: 'Objeto > Distribuir > Distribuição vertical centralizada',
        placement: 'MenuBar',
        name: 'Distribuição vertical centralizada',
    },
    {
        id: 2164261357,
        label: 'Objeto > Distribuir > Distribuição vertical inferior',
        placement: 'MenuBar',
        name: 'Distribuição vertical inferior',
    },
    {
        id: 2164261358,
        label: 'Objeto > Distribuir > Distribuição horizontal à esquerda',
        placement: 'MenuBar',
        name: 'Distribuição horizontal à esquerda',
    },
    {
        id: 2164261359,
        label: 'Objeto > Distribuir > Distribuição horizontal centralizada',
        placement: 'MenuBar',
        name: 'Distribuição horizontal centralizada',
    },
    {
        id: 2164261360,
        label: 'Objeto > Distribuir > Distribuição horizontal à direita',
        placement: 'MenuBar',
        name: 'Distribuição horizontal à direita',
    },
    {
        id: 2164261361,
        label: 'Janela > Transformar',
        placement: 'MenuBar',
        name: 'Transformar',
    },
    {
        id: 2164261363,
        label: 'Objeto > Repetir > Radial',
        placement: 'MenuBar',
        name: 'Radial',
    },
    {
        id: 2164261364,
        label: 'Objeto > Repetir > Grade',
        placement: 'MenuBar',
        name: 'Grade',
    },
    {
        id: 2164261365,
        label: 'Objeto > Repetir > Espelhar',
        placement: 'MenuBar',
        name: 'Espelhar',
    },
    {
        id: 2164261367,
        label: 'Objeto > Repetir > Liberar',
        placement: 'MenuBar',
        name: 'Liberar',
    },
    {
        id: 2164261368,
        label: 'Objeto > Repetir > Opções...',
        placement: 'MenuBar',
        name: 'Opções...',
    },
    {
        id: 2164261370,
        label: 'Objeto > Objetos no caminho > Anexar...',
        placement: 'MenuBar',
        name: 'Anexar...',
    },
    {
        id: 2164261371,
        label: 'Objeto > Objetos no caminho > Opções...',
        placement: 'MenuBar',
        name: 'Opções...',
    },
    {
        id: 2164261372,
        label: 'Objeto > Objetos no caminho > Expansão',
        placement: 'MenuBar',
        name: 'Expansão',
    },
    {
        id: 2164261374,
        label: 'Objeto > Modelo > Visualizar modelo',
        placement: 'MenuBar',
        name: 'Visualizar modelo',
    },
    {
        id: 2164261375,
        label: 'Objeto > Modelo > Liberar',
        placement: 'MenuBar',
        name: 'Liberar',
    },
    {
        id: 2164261376,
        label: 'Objeto > Modelo > Editar',
        placement: 'MenuBar',
        name: 'Editar',
    },
    {
        id: 2164261377,
        label: 'Janela > Atributos',
        placement: 'MenuBar',
        name: 'Atributos',
    },
    {
        id: 2164261378,
        label: 'Tipo > Veja mais em Fontes Adobe...',
        placement: 'MenuBar',
        name: 'Veja mais em Fontes Adobe...',
    },
    {
        id: 2164261379,
        label: 'Tipo > Solucionar problema de fontes ausentes...',
        placement: 'MenuBar',
        name: 'Solucionar problema de fontes ausentes...',
    },
    {
        id: 2164261380,
        label: 'Ajuda > Comunidade de suporte',
        placement: 'MenuBar',
        name: 'Comunidade de suporte',
    },
    {
        id: 2164261381,
        label: 'Ajuda > Enviar bug/Pedido de funcionalidades...',
        placement: 'MenuBar',
        name: 'Enviar bug/Pedido de funcionalidades...',
    },
    {
        id: 2164261383,
        label: 'Objeto > Tornar pixels perfeitos',
        placement: 'MenuBar',
        name: 'Tornar pixels perfeitos',
    },
    {
        id: 2164261384,
        label: 'Janela > Tipo > Visualizador do Reflow',
        placement: 'MenuBar',
        name: 'Visualizador do Reflow',
    },
    {
        id: 2164261385,
        label: 'Ajuda > Diretrizes do usuário de IA generativa',
        placement: 'MenuBar',
        name: 'Diretrizes do usuário de IA generativa',
    },
    {
        id: 2164261387,
        label: 'Editar > Predefinições de nivelador de transparência...',
        placement: 'MenuBar',
        name: 'Predefinições de nivelador de transparência...',
    },
    {
        id: 2164261389,
        label: 'Objeto > Nivelar transparência...',
        placement: 'MenuBar',
        name: 'Nivelar transparência...',
    },
    {
        id: 2164261391,
        label: 'Objeto > Forma > Converter para forma',
        placement: 'MenuBar',
        name: 'Converter para forma',
    },
    {
        id: 2164261392,
        label: 'Objeto > Forma > Expandir forma',
        placement: 'MenuBar',
        name: 'Expandir forma',
    },
    {
        id: 2164261393,
        label: 'Janela > Modelo',
        placement: 'MenuBar',
        name: 'Modelo',
    },
    {
        id: 2164261394,
        label: 'Janela > Variações geradas',
        placement: 'MenuBar',
        name: 'Variações geradas',
    },
    {
        id: 2164261395,
        label: 'Objeto > Gerar vetores (Beta)...',
        placement: 'MenuBar',
        name: 'Gerar vetores (Beta)...',
    },
    {
        id: 2164261396,
        label: 'Arquivo > Gerar vetores (Beta)...',
        placement: 'MenuBar',
        name: 'Gerar vetores (Beta)...',
    },
    {
        id: 2164261397,
        label: 'Objeto > Preenchimento de forma generativo (Beta)...',
        placement: 'MenuBar',
        name: 'Preenchimento de forma generativo (Beta)...',
    },
    {
        id: 2164261398,
        label: 'Janela > 3D e materiais',
        placement: 'MenuBar',
        name: '3D e materiais',
    },
    {
        id: 2164261399,
        label: 'Janela > Traçado da imagem',
        placement: 'MenuBar',
        name: 'Traçado da imagem',
    },
    {
        id: 2164261401,
        label: 'Objeto > Traçado da imagem > Criar',
        placement: 'MenuBar',
        name: 'Criar',
    },
    {
        id: 2164261402,
        label: 'Objeto > Traçado da imagem > Criar e expandir',
        placement: 'MenuBar',
        name: 'Criar e expandir',
    },
    {
        id: 2164261403,
        label: 'Objeto > Traçado da imagem > Liberar',
        placement: 'MenuBar',
        name: 'Liberar',
    },
    {
        id: 2164261405,
        label: 'Objeto > Traçado da imagem > Expandir',
        placement: 'MenuBar',
        name: 'Expandir',
    },
    {
        id: 2164261406,
        label: 'Janela > Propriedades CSS (obsoleto)',
        placement: 'MenuBar',
        name: 'Propriedades CSS (obsoleto)',
    },
    {
        id: 2164261408,
        label: 'Efeito > Caminho > Contornar objeto',
        placement: 'MenuBar',
        name: 'Contornar objeto',
    },
    {
        id: 2164261409,
        label: 'Editar > Predefinições de Adobe PDF...',
        placement: 'MenuBar',
        name: 'Predefinições de Adobe PDF...',
    },
    {
        id: 2164261410,
        label: 'Janela > Exportação de ativos',
        placement: 'MenuBar',
        name: 'Exportação de ativos',
    },
    {
        id: 2164261411,
        label: 'Efeito > Vídeo > Cores NTSC',
        placement: 'MenuBar',
        name: 'Cores NTSC',
    },
    {
        id: 2164261413,
        label: 'Efeito > Artístico > Aquarela...',
        placement: 'MenuBar',
        name: 'Aquarela...',
    },
    {
        id: 2164261415,
        label: 'Efeito > Croqui > Papel Molhado...',
        placement: 'MenuBar',
        name: 'Papel Molhado...',
    },
    {
        id: 2164261416,
        label: 'Efeito > Artístico > Tinta-Base...',
        placement: 'MenuBar',
        name: 'Tinta-Base...',
    },
    {
        id: 2164261417,
        label: 'Efeito > Croqui > Arestas Rasgadas...',
        placement: 'MenuBar',
        name: 'Arestas Rasgadas...',
    },
    {
        id: 2164261419,
        label: 'Efeito > Textura > Texturizador...',
        placement: 'MenuBar',
        name: 'Texturizador...',
    },
    {
        id: 2164261421,
        label: 'Efeito > Traçados de Pincel > Sumi-e...',
        placement: 'MenuBar',
        name: 'Sumi-e...',
    },
    {
        id: 2164261422,
        label: 'Efeito > Croqui > Estampa...',
        placement: 'MenuBar',
        name: 'Estampa...',
    },
    {
        id: 2164261423,
        label: 'Efeito > Textura > Vitral...',
        placement: 'MenuBar',
        name: 'Vitral...',
    },
    {
        id: 2164261424,
        label: 'Efeito > Traçados de Pincel > Traçado Borrifado...',
        placement: 'MenuBar',
        name: 'Traçado Borrifado...',
    },
    {
        id: 2164261425,
        label: 'Efeito > Artístico > Esponja...',
        placement: 'MenuBar',
        name: 'Esponja...',
    },
    {
        id: 2164261426,
        label: 'Efeito > Traçados de Pincel > Respingo...',
        placement: 'MenuBar',
        name: 'Respingo...',
    },
    {
        id: 2164261427,
        label: 'Efeito > Artístico > Bastão de Borrar...',
        placement: 'MenuBar',
        name: 'Bastão de Borrar...',
    },
    {
        id: 2164261428,
        label: 'Efeito > Artístico > Pastéis Ásperos...',
        placement: 'MenuBar',
        name: 'Pastéis Ásperos...',
    },
    {
        id: 2164261429,
        label: 'Efeito > Croqui > Reticulação...',
        placement: 'MenuBar',
        name: 'Reticulação...',
    },
    {
        id: 2164261430,
        label: 'Efeito > Artístico > Arestas Posterizadas...',
        placement: 'MenuBar',
        name: 'Arestas Posterizadas...',
    },
    {
        id: 2164261431,
        label: 'Efeito > Artístico > Plastificação...',
        placement: 'MenuBar',
        name: 'Plastificação...',
    },
    {
        id: 2164261432,
        label: 'Efeito > Croqui > Gesso...',
        placement: 'MenuBar',
        name: 'Gesso...',
    },
    {
        id: 2164261433,
        label: 'Efeito > Croqui > Fotocópia...',
        placement: 'MenuBar',
        name: 'Fotocópia...',
    },
    {
        id: 2164261434,
        label: 'Efeito > Textura > Bordado...',
        placement: 'MenuBar',
        name: 'Bordado...',
    },
    {
        id: 2164261435,
        label: 'Efeito > Artístico > Espátula...',
        placement: 'MenuBar',
        name: 'Espátula...',
    },
    {
        id: 2164261436,
        label: 'Efeito > Artístico > Toques de Tinta...',
        placement: 'MenuBar',
        name: 'Toques de Tinta...',
    },
    {
        id: 2164261438,
        label: 'Efeito > Distorção > Marola...',
        placement: 'MenuBar',
        name: 'Marola...',
    },
    {
        id: 2164261439,
        label: 'Efeito > Croqui > Papel de Carta...',
        placement: 'MenuBar',
        name: 'Papel de Carta...',
    },
    {
        id: 2164261440,
        label: 'Efeito > Artístico > Néon...',
        placement: 'MenuBar',
        name: 'Néon...',
    },
    {
        id: 2164261441,
        label: 'Efeito > Textura > Ladrilhos do Mosaico...',
        placement: 'MenuBar',
        name: 'Ladrilhos do Mosaico...',
    },
    {
        id: 2164261442,
        label: 'Efeito > Traçados de Pincel > Rastro da Tinta...',
        placement: 'MenuBar',
        name: 'Rastro da Tinta...',
    },
    {
        id: 2164261443,
        label: 'Efeito > Croqui > Matriz de Meio-Tom...',
        placement: 'MenuBar',
        name: 'Matriz de Meio-Tom...',
    },
    {
        id: 2164261444,
        label: 'Efeito > Croqui > Bico de Pena...',
        placement: 'MenuBar',
        name: 'Bico de Pena...',
    },
    {
        id: 2164261445,
        label: 'Efeito > Textura > Granulado...',
        placement: 'MenuBar',
        name: 'Granulado...',
    },
    {
        id: 2164261447,
        label: 'Efeito > Estilização > Arestas Brilhantes...',
        placement: 'MenuBar',
        name: 'Arestas Brilhantes...',
    },
    {
        id: 2164261448,
        label: 'Efeito > Distorção > Vidro...',
        placement: 'MenuBar',
        name: 'Vidro...',
    },
    {
        id: 2164261449,
        label: 'Efeito > Artístico > Afresco...',
        placement: 'MenuBar',
        name: 'Afresco...',
    },
    {
        id: 2164261450,
        label: 'Efeito > Artístico > Foto Granulada...',
        placement: 'MenuBar',
        name: 'Foto Granulada...',
    },
    {
        id: 2164261451,
        label: 'Efeito > Artístico > Pincel a Seco...',
        placement: 'MenuBar',
        name: 'Pincel a Seco...',
    },
    {
        id: 2164261452,
        label: 'Efeito > Distorção > Brilho Difuso...',
        placement: 'MenuBar',
        name: 'Brilho Difuso...',
    },
    {
        id: 2164261453,
        label: 'Efeito > Traçados de Pincel > Traçado Escuro...',
        placement: 'MenuBar',
        name: 'Traçado Escuro...',
    },
    {
        id: 2164261454,
        label: 'Efeito > Artístico > Recorte de Arestas...',
        placement: 'MenuBar',
        name: 'Recorte de Arestas...',
    },
    {
        id: 2164261455,
        label: 'Efeito > Traçados de Pincel > Hachura...',
        placement: 'MenuBar',
        name: 'Hachura...',
    },
    {
        id: 2164261456,
        label: 'Efeito > Textura > Craquelé...',
        placement: 'MenuBar',
        name: 'Craquelé...',
    },
    {
        id: 2164261457,
        label: 'Efeito > Croqui > Crayon Cont^e...',
        placement: 'MenuBar',
        name: 'Crayon Cont^e...',
    },
    {
        id: 2164261458,
        label: 'Efeito > Artístico > Lápis de Cor...',
        placement: 'MenuBar',
        name: 'Lápis de Cor...',
    },
    {
        id: 2164261459,
        label: 'Efeito > Croqui > Cromo...',
        placement: 'MenuBar',
        name: 'Cromo...',
    },
    {
        id: 2164261460,
        label: 'Efeito > Croqui > Carvão...',
        placement: 'MenuBar',
        name: 'Carvão...',
    },
    {
        id: 2164261461,
        label: 'Efeito > Croqui > Giz e Carvão...',
        placement: 'MenuBar',
        name: 'Giz e Carvão...',
    },
    {
        id: 2164261462,
        label: 'Efeito > Croqui > Baixo-Relevo...',
        placement: 'MenuBar',
        name: 'Baixo-Relevo...',
    },
    {
        id: 2164261463,
        label: 'Efeito > Traçados de Pincel > Traçado Angular...',
        placement: 'MenuBar',
        name: 'Traçado Angular...',
    },
    {
        id: 2164261464,
        label: 'Efeito > Traçados de Pincel > Arestas Acentuadas...',
        placement: 'MenuBar',
        name: 'Arestas Acentuadas...',
    },
    {
        id: 2164261465,
        label: 'Efeito > Galeria de efeitos...',
        placement: 'MenuBar',
        name: 'Galeria de efeitos...',
    },
    {
        id: 2164261467,
        label: 'Efeito > Distorcer e transformar > Transformar...',
        placement: 'MenuBar',
        name: 'Transformar...',
    },
    {
        id: 2164261469,
        label: 'Efeito > Estilizar > Sombra...',
        placement: 'MenuBar',
        name: 'Sombra...',
    },
    {
        id: 2164261470,
        label: 'Efeito > Estilizar > Brilho externo...',
        placement: 'MenuBar',
        name: 'Brilho externo...',
    },
    {
        id: 2164261471,
        label: 'Efeito > Estilizar > Brilho interno...',
        placement: 'MenuBar',
        name: 'Brilho interno...',
    },
    {
        id: 2164261473,
        label: 'Efeito > Converter em forma > Retângulo...',
        placement: 'MenuBar',
        name: 'Retângulo...',
    },
    {
        id: 2164261474,
        label: 'Efeito > Converter em forma > Retângulo arredondado...',
        placement: 'MenuBar',
        name: 'Retângulo arredondado...',
    },
    {
        id: 2164261475,
        label: 'Efeito > Converter em forma > Elipse...',
        placement: 'MenuBar',
        name: 'Elipse...',
    },
    {
        id: 2164261476,
        label: 'Efeito > Estilizar > Cantos arredondados...',
        placement: 'MenuBar',
        name: 'Cantos arredondados...',
    },
    {
        id: 2164261477,
        label: 'Efeito > Distorcer e transformar > Distorção livre...',
        placement: 'MenuBar',
        name: 'Distorção livre...',
    },
    {
        id: 2164261478,
        label: 'Efeito > Distorcer e transformar > Esvaziar e inflar...',
        placement: 'MenuBar',
        name: 'Esvaziar e inflar...',
    },
    {
        id: 2164261479,
        label: 'Efeito > Distorcer e transformar > Pinçar...',
        placement: 'MenuBar',
        name: 'Pinçar...',
    },
    {
        id: 2164261480,
        label: 'Efeito > Distorcer e transformar > Tornar áspero...',
        placement: 'MenuBar',
        name: 'Tornar áspero...',
    },
    {
        id: 2164261481,
        label: 'Efeito > Distorcer e transformar > Ziguezague...',
        placement: 'MenuBar',
        name: 'Ziguezague...',
    },
    {
        id: 2164261482,
        label: 'Efeito > Estilizar > Rabiscar...',
        placement: 'MenuBar',
        name: 'Rabiscar...',
    },
    {
        id: 2164261484,
        label: 'Efeito > Deformação > Arco...',
        placement: 'MenuBar',
        name: 'Arco...',
    },
    {
        id: 2164261485,
        label: 'Efeito > Deformação > Arco inferior...',
        placement: 'MenuBar',
        name: 'Arco inferior...',
    },
    {
        id: 2164261486,
        label: 'Efeito > Deformação > Arco superior...',
        placement: 'MenuBar',
        name: 'Arco superior...',
    },
    {
        id: 2164261487,
        label: 'Efeito > Deformação > Abóbada...',
        placement: 'MenuBar',
        name: 'Abóbada...',
    },
    {
        id: 2164261488,
        label: 'Efeito > Deformação > Saliência...',
        placement: 'MenuBar',
        name: 'Saliência...',
    },
    {
        id: 2164261489,
        label: 'Efeito > Deformação > Concha inferior...',
        placement: 'MenuBar',
        name: 'Concha inferior...',
    },
    {
        id: 2164261490,
        label: 'Efeito > Deformação > Concha superior...',
        placement: 'MenuBar',
        name: 'Concha superior...',
    },
    {
        id: 2164261491,
        label: 'Efeito > Deformação > Bandeira...',
        placement: 'MenuBar',
        name: 'Bandeira...',
    },
    {
        id: 2164261492,
        label: 'Efeito > Deformação > Onda...',
        placement: 'MenuBar',
        name: 'Onda...',
    },
    {
        id: 2164261493,
        label: 'Efeito > Deformação > Peixe...',
        placement: 'MenuBar',
        name: 'Peixe...',
    },
    {
        id: 2164261494,
        label: 'Efeito > Deformação > Elevação...',
        placement: 'MenuBar',
        name: 'Elevação...',
    },
    {
        id: 2164261495,
        label: 'Efeito > Deformação > Olho de peixe...',
        placement: 'MenuBar',
        name: 'Olho de peixe...',
    },
    {
        id: 2164261496,
        label: 'Efeito > Deformação > Inflar...',
        placement: 'MenuBar',
        name: 'Inflar...',
    },
    {
        id: 2164261497,
        label: 'Efeito > Deformação > Comprimir...',
        placement: 'MenuBar',
        name: 'Comprimir...',
    },
    {
        id: 2164261498,
        label: 'Efeito > Deformação > Torcer...',
        placement: 'MenuBar',
        name: 'Torcer...',
    },
    {
        id: 2164261499,
        label: 'Efeito > Rasterizar...',
        placement: 'MenuBar',
        name: 'Rasterizar...',
    },
    {
        id: 2164261501,
        label: 'Efeito > Filtros SVG > Aplicar filtro SVG...',
        placement: 'MenuBar',
        name: 'Aplicar filtro SVG...',
    },
    {
        id: 2164261502,
        label: 'Efeito > Estilizar > Difusão...',
        placement: 'MenuBar',
        name: 'Difusão...',
    },
    {
        id: 2164261503,
        label: 'Efeito > Distorcer e transformar > Torcer...',
        placement: 'MenuBar',
        name: 'Torcer...',
    },
    {
        id: 2164261504,
        label: 'Efeito > Caminho > Contornar traçado',
        placement: 'MenuBar',
        name: 'Contornar traçado',
    },
    {
        id: 2164261505,
        label: 'Efeito > Caminho > Deslocar caminho...',
        placement: 'MenuBar',
        name: 'Deslocar caminho...',
    },
    {
        id: 2164261506,
        label: 'Efeito > Desfoque > Desfoque gaussiano...',
        placement: 'MenuBar',
        name: 'Desfoque gaussiano...',
    },
    {
        id: 2164261507,
        label: 'Editar > Editar dicionário personalizado...',
        placement: 'MenuBar',
        name: 'Editar dicionário personalizado...',
    },
    {
        id: 2164261510,
        label: 'Objeto > Caminho > Dividir em grade...',
        placement: 'MenuBar',
        name: 'Dividir em grade...',
    },
    {
        id: 2164261512,
        label: 'Tipo > Alterar caixa alta/baixa > MAIÚSCULA',
        placement: 'MenuBar',
        name: 'MAIÚSCULA',
    },
    {
        id: 2164261513,
        label: 'Tipo > Alterar caixa alta/baixa > minúscula',
        placement: 'MenuBar',
        name: 'minúscula',
    },
    {
        id: 2164261514,
        label: 'Tipo > Alterar caixa alta/baixa > Primeira letra da palavra maiúscula',
        placement: 'MenuBar',
        name: 'Primeira letra da palavra maiúscula',
    },
    {
        id: 2164261515,
        label: 'Tipo > Alterar caixa alta/baixa > Primeira letra da sentença maiúscula',
        placement: 'MenuBar',
        name: 'Primeira letra da sentença maiúscula',
    },
    {
        id: 2164261516,
        label: 'Tipo > Alinhamento óptico da margem',
        placement: 'MenuBar',
        name: 'Alinhamento óptico da margem',
    },
    {
        id: 2164261517,
        label: 'Tipo > Localizar/Substituir fonte...',
        placement: 'MenuBar',
        name: 'Localizar/Substituir fonte...',
    },
    {
        id: 2164261518,
        label: 'Tipo > Pontuação inteligente...',
        placement: 'MenuBar',
        name: 'Pontuação inteligente...',
    },
    {
        id: 2164261519,
        label: 'Objeto > Transformar > Transformar cada...',
        placement: 'MenuBar',
        name: 'Transformar cada...',
    },
    {
        id: 2164261520,
        label: 'Objeto > Criar malha de gradiente...',
        placement: 'MenuBar',
        name: 'Criar malha de gradiente...',
    },
    {
        id: 2164261521,
        label: 'Selecionar > Inverter',
        placement: 'MenuBar',
        name: 'Inverter',
    },
    {
        id: 2164261523,
        label: 'Objeto > Caminho > Limpar...',
        placement: 'MenuBar',
        name: 'Limpar...',
    },
    {
        id: 2164261524,
        label: 'Editar > Editar cores > Superimposição em preto...',
        placement: 'MenuBar',
        name: 'Superimposição em preto...',
    },
    {
        id: 2164261526,
        label: 'Objeto > Texto em contorno > Criar',
        placement: 'MenuBar',
        name: 'Criar',
    },
    {
        id: 2164261527,
        label: 'Objeto > Texto em contorno > Liberar',
        placement: 'MenuBar',
        name: 'Liberar',
    },
    {
        id: 2164261529,
        label: 'Objeto > Texto em contorno > Opções de texto em contorno...',
        placement: 'MenuBar',
        name: 'Opções de texto em contorno...',
    },
    {
        id: 2164261530,
        label: 'Selecionar > Objeto > Máscaras de recorte',
        placement: 'MenuBar',
        name: 'Máscaras de recorte',
    },
    {
        id: 2164261531,
        label: 'Editar > Editar cores > Saturar...',
        placement: 'MenuBar',
        name: 'Saturar...',
    },
    {
        id: 2164261533,
        label: 'Objeto > Caminho > Adicionar pontos âncora',
        placement: 'MenuBar',
        name: 'Adicionar pontos âncora',
    },
    {
        id: 2164261534,
        label: 'Editar > Editar cores > Ajustar equilíbrio de cores...',
        placement: 'MenuBar',
        name: 'Ajustar equilíbrio de cores...',
    },
    {
        id: 2164261535,
        label: 'Objeto > Criar mosaico de objetos...',
        placement: 'MenuBar',
        name: 'Criar mosaico de objetos...',
    },
    {
        id: 2164261536,
        label: 'Arquivo > Pacote...',
        placement: 'MenuBar',
        name: 'Pacote...',
    },
    {
        id: 2164261537,
        label: 'Arquivo > Procurar no Bridge...',
        placement: 'MenuBar',
        name: 'Procurar no Bridge...',
    },
    {
        id: 2164261538,
        label: 'Arquivo > Informações do arquivo...',
        placement: 'MenuBar',
        name: 'Informações do arquivo...',
    },
    {
        id: 2164261540,
        label: 'Objeto > Distorção de envelope > Criar com deformação...',
        placement: 'MenuBar',
        name: 'Criar com deformação...',
    },
    {
        id: 2164261541,
        label: 'Objeto > Distorção de envelope > Criar com malha...',
        placement: 'MenuBar',
        name: 'Criar com malha...',
    },
    {
        id: 2164261542,
        label: 'Objeto > Distorção de envelope > Criar com objeto superior',
        placement: 'MenuBar',
        name: 'Criar com objeto superior',
    },
    {
        id: 2164261543,
        label: 'Objeto > Distorção de envelope > Liberar',
        placement: 'MenuBar',
        name: 'Liberar',
    },
    {
        id: 2164261545,
        label: 'Objeto > Distorção de envelope > Opções de envelope...',
        placement: 'MenuBar',
        name: 'Opções de envelope...',
    },
    {
        id: 2164261547,
        label: 'Objeto > Distorção de envelope > Expandir',
        placement: 'MenuBar',
        name: 'Expandir',
    },
    {
        id: 2164261549,
        label: 'Objeto > Distorção de envelope > Editar conteúdo',
        placement: 'MenuBar',
        name: 'Editar conteúdo',
    },
    {
        id: 2164261551,
        label: 'Editar > Verificação ortográfica > Corretor ortográfico automático',
        placement: 'MenuBar',
        name: 'Corretor ortográfico automático',
    },
    {
        id: 2164261552,
        label: 'Editar > Verificação ortográfica > Verificar ortografia...',
        placement: 'MenuBar',
        name: 'Verificar ortografia...',
    },
    {
        id: 2164261553,
        label: 'Selecionar > Iniciar Edição global',
        placement: 'MenuBar',
        name: 'Iniciar Edição global',
    },
    {
        id: 2164261554,
        label: 'Editar > Localizar e substituir...',
        placement: 'MenuBar',
        name: 'Localizar e substituir...',
    },
    {
        id: 2164261555,
        label: 'Editar > Localizar próximo',
        placement: 'MenuBar',
        name: 'Localizar próximo',
    },
    {
        id: 2164261557,
        label: 'Efeito > Configurações de efeitos de rasterização do documento...',
        placement: 'MenuBar',
        name: 'Configurações de efeitos de rasterização do documento...',
    },
    {
        id: 2164261558,
        label: 'Objeto > Rasterizar...',
        placement: 'MenuBar',
        name: 'Rasterizar...',
    },
    {
        id: 2164261559,
        label: 'Arquivo > Salvar fatias selecionadas...',
        placement: 'MenuBar',
        name: 'Salvar fatias selecionadas...',
    },
    {
        id: 2164261560,
        label: 'Efeito > Filtros SVG > Importar filtro SVG...',
        placement: 'MenuBar',
        name: 'Importar filtro SVG...',
    },
    {
        id: 2164261562,
        label: 'Objeto > Cortar imagem',
        placement: 'MenuBar',
        name: 'Cortar imagem',
    },
    {
        id: 2164261563,
        label: 'Objeto > Organizar > Enviar para camada atual',
        placement: 'MenuBar',
        name: 'Enviar para camada atual',
    },
    {
        id: 2164261565,
        label: 'Objeto > Bloquear > Toda arte acima',
        placement: 'MenuBar',
        name: 'Toda arte acima',
    },
    {
        id: 2164261566,
        label: 'Objeto > Bloquear > Outras camadas',
        placement: 'MenuBar',
        name: 'Outras camadas',
    },
    {
        id: 2164261567,
        label: 'Objeto > Ocultar > Toda arte acima',
        placement: 'MenuBar',
        name: 'Toda arte acima',
    },
    {
        id: 2164261568,
        label: 'Objeto > Ocultar > Outras camadas',
        placement: 'MenuBar',
        name: 'Outras camadas',
    },
    {
        id: 2164261569,
        label: 'Selecionar > Objeto > Tudo nas mesmas camadas',
        placement: 'MenuBar',
        name: 'Tudo nas mesmas camadas',
    },
    {
        id: 2164261570,
        label: 'Selecionar > Objeto > Alças de direção',
        placement: 'MenuBar',
        name: 'Alças de direção',
    },
    {
        id: 2164261573,
        label: 'Selecionar > Próximo objeto acima',
        placement: 'MenuBar',
        name: 'Próximo objeto acima',
    },
    {
        id: 2164261574,
        label: 'Selecionar > Próximo objeto abaixo',
        placement: 'MenuBar',
        name: 'Próximo objeto abaixo',
    },
    {
        id: 2164261577,
        label: 'Selecionar > Salvar seleção...',
        placement: 'MenuBar',
        name: 'Salvar seleção...',
    },
    {
        id: 2164261578,
        label: 'Selecionar > Editar seleção...',
        placement: 'MenuBar',
        name: 'Editar seleção...',
    },
    {
        id: 2164261579,
        label: 'Selecionar > Atualizar seleção',
        placement: 'MenuBar',
        name: 'Atualizar seleção',
    },
    {
        id: 2164261583,
        label: 'Arquivo > Scripts > Outro script...',
        placement: 'MenuBar',
        name: 'Outro script...',
    },
    {
        id: 2164261584,
        label: 'Exibir > Ocultar widget de canto',
        placement: 'MenuBar',
        name: 'Ocultar widget de canto',
    },
    {
        id: 2164261585,
        label: 'Objeto > Caminho > Contornar traçado',
        placement: 'MenuBar',
        name: 'Contornar traçado',
    },
    {
        id: 2164261586,
        label: 'Objeto > Caminho > Deslocar caminho...',
        placement: 'MenuBar',
        name: 'Deslocar caminho...',
    },
    {
        id: 2164261587,
        label: 'Editar > Predefinições de impressão...',
        placement: 'MenuBar',
        name: 'Predefinições de impressão...',
    },
    {
        id: 2164261588,
        label: 'Arquivo > Imprimir...',
        placement: 'MenuBar',
        name: 'Imprimir...',
    },
    {
        id: 2164261590,
        label: 'Objeto > Perspectiva > Associar ao plano ativo',
        placement: 'MenuBar',
        name: 'Associar ao plano ativo',
    },
    {
        id: 2164261591,
        label: 'Objeto > Perspectiva > Liberar com perspectiva',
        placement: 'MenuBar',
        name: 'Liberar com perspectiva',
    },
    {
        id: 2164261592,
        label: 'Objeto > Perspectiva > Mover plano para Corresponder ao objeto',
        placement: 'MenuBar',
        name: 'Mover plano para Corresponder ao objeto',
    },
    {
        id: 2164261593,
        label: 'Objeto > Perspectiva > Editar texto',
        placement: 'MenuBar',
        name: 'Editar texto',
    },
    {
        id: 2164261594,
        label: 'Editar > Predefinições da grade de perspectiva...',
        placement: 'MenuBar',
        name: 'Predefinições da grade de perspectiva...',
    },
    {
        id: 2164261597,
        label: 'Exibir > Grade de perspectiva > Mostrar grade',
        placement: 'MenuBar',
        name: 'Mostrar grade',
    },
    {
        id: 2164261598,
        label: 'Exibir > Grade de perspectiva > Mostrar réguas',
        placement: 'MenuBar',
        name: 'Mostrar réguas',
    },
    {
        id: 2164261599,
        label: 'Exibir > Grade de perspectiva > Encaixar na grade',
        placement: 'MenuBar',
        name: 'Encaixar na grade',
    },
    {
        id: 2164261600,
        label: 'Exibir > Grade de perspectiva > Bloquear grade',
        placement: 'MenuBar',
        name: 'Bloquear grade',
    },
    {
        id: 2164261601,
        label: 'Exibir > Grade de perspectiva > Bloquear ponto de posição',
        placement: 'MenuBar',
        name: 'Bloquear ponto de posição',
    },
    {
        id: 2164261603,
        label: 'Exibir > Grade de perspectiva > Definir grade...',
        placement: 'MenuBar',
        name: 'Definir grade...',
    },
    {
        id: 2164261609,
        label: 'Exibir > Grade de perspectiva > Salvar grade como predefinição...',
        placement: 'MenuBar',
        name: 'Salvar grade como predefinição...',
    },
    {
        id: 2164261610,
        label: 'Arquivo > Convidar para editar...',
        placement: 'MenuBar',
        name: 'Convidar para editar...',
    },
    {
        id: 2164261611,
        label: 'Arquivo > Compartilhar para revisão…',
        placement: 'MenuBar',
        name: 'Compartilhar para revisão…',
    },
    {
        id: 2164261614,
        label: 'Janela > Extensões > Bibliotecas',
        placement: 'MenuBar',
        name: 'Bibliotecas',
    },
    {
        id: 2164261615,
        label: 'Janela > Histórico da versão',
        placement: 'MenuBar',
        name: 'Histórico da versão',
    },
    {
        id: 2164261616,
        label: 'Arquivo > Histórico da versão',
        placement: 'MenuBar',
        name: 'Histórico da versão',
    },
    {
        id: 2164261617,
        label: 'Janela > Comentários',
        placement: 'MenuBar',
        name: 'Comentários',
    },
    {
        id: 2164261618,
        label: 'Exibir > Grade de perspectiva > Perspectiva de um ponto > [1P-Exibição normal]',
        placement: 'MenuBar',
        name: '[1P-Exibição normal]',
    },
    {
        id: 2164261619,
        label: 'Exibir > Grade de perspectiva > Perspectiva de dois pontos > [2P-Exibição normal]',
        placement: 'MenuBar',
        name: '[2P-Exibição normal]',
    },
    {
        id: 2164261620,
        label: 'Exibir > Grade de perspectiva > Perspectiva de três pontos > [3P-Exibição normal]',
        placement: 'MenuBar',
        name: '[3P-Exibição normal]',
    },
    {
        id: 'Adobe Scroll Tool',
        label: 'Ferramenta Mão',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pen Tool',
        label: 'Ferramenta Caneta',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scale Tool',
        label: 'Ferramenta Dimensionar',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rotate Tool',
        label: 'Ferramenta Girar',
        placement: 'Tool',
    },
    {
        id: 'Adobe Reflect Tool',
        label: 'Ferramenta Refletir',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shear Tool',
        label: 'Ferramenta Inclinar',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scissors Tool',
        label: 'Ferramenta Tesoura',
        placement: 'Tool',
    },
    {
        id: 'Adobe Measure Tool',
        label: 'Ferramenta Medida',
        placement: 'Tool',
    },
    {
        id: 'Adobe Page Tool',
        label: 'Ferramenta Imprimir lado a lado',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Object Select Tool',
        label: 'Ferramenta Seleção de grupos',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Select Tool',
        label: 'Ferramenta Seleção direta',
        placement: 'Tool',
    },
    {
        id: 'Adobe Select Tool',
        label: 'Ferramenta Seleção',
        placement: 'Tool',
    },
    {
        id: 'Adobe Zoom Tool',
        label: 'Ferramenta Zoom',
        placement: 'Tool',
    },
    {
        id: 'Adobe Add Anchor Point Tool',
        label: 'Ferramenta Adicionar ponto âncora',
        placement: 'Tool',
    },
    {
        id: 'Adobe Delete Anchor Point Tool',
        label: 'Ferramenta Excluir ponto âncora',
        placement: 'Tool',
    },
    {
        id: 'Adobe Anchor Point Tool',
        label: 'Ferramenta Ponto de ancoragem',
        placement: 'Tool',
    },
    {
        id: 'Adobe Column Graph Tool',
        label: 'Ferramenta Gráfico de colunas',
        placement: 'Tool',
    },
    {
        id: 'Adobe Stacked Column Graph Tool',
        label: 'Ferramenta Gráfico de colunas empilhadas',
        placement: 'Tool',
    },
    {
        id: 'Adobe Line Graph Tool',
        label: 'Ferramenta Gráfico de linhas',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pie Graph Tool',
        label: 'Ferramenta Gráfico de pizza',
        placement: 'Tool',
    },
    {
        id: 'Adobe Area Graph Tool',
        label: 'Ferramenta Gráfico de áreas',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scatter Graph Tool',
        label: 'Ferramenta Gráfico de dispersão',
        placement: 'Tool',
    },
    {
        id: 'Adobe Bar Graph Tool',
        label: 'Ferramenta Gráfico de barras',
        placement: 'Tool',
    },
    {
        id: 'Adobe Stacked Bar Graph Tool',
        label: 'Ferramenta Gráfico de barras empilhadas',
        placement: 'Tool',
    },
    {
        id: 'Adobe Radar Graph Tool',
        label: 'Ferramenta Gráfico de radar',
        placement: 'Tool',
    },
    {
        id: 'Adobe Type Tool',
        label: 'Ferramenta Tipo',
        placement: 'Tool',
    },
    {
        id: 'Adobe Area Type Tool',
        label: 'Ferramenta Tipo de área',
        placement: 'Tool',
    },
    {
        id: 'Adobe Path Type Tool',
        label: 'Ferramenta Tipo no caminho',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Type Tool',
        label: 'Ferramenta Tipo vertical',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Area Type Tool',
        label: 'Ferramenta Tipo de área vertical',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Path Type Tool',
        label: 'Ferramenta Tipo no caminho vertical',
        placement: 'Tool',
    },
    {
        id: 'Adobe Touch Type Tool',
        label: 'Ferramenta Datilografia',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Builder Tool',
        label: 'Ferramenta Construtor de formas',
        placement: 'Tool',
    },
    {
        id: 'Adobe Planar Paintbucket Tool',
        label: 'Balde de tinta em tempo real',
        placement: 'Tool',
    },
    {
        id: 'Adobe Planar Face Select Tool',
        label: 'Ferramenta Seleção de pintura em tempo real',
        placement: 'Tool',
    },
    {
        id: 'Adobe Dimension Tool',
        label: 'Ferramenta de dimensão',
        placement: 'Tool',
    },
    {
        id: 'Adobe Gradient Vector Tool',
        label: 'Ferramenta Gradiente',
        placement: 'Tool',
    },
    {
        id: 'Adobe Blend Tool',
        label: 'Ferramenta Mesclagem',
        placement: 'Tool',
    },
    {
        id: 'Adobe Slice Tool',
        label: 'Ferramenta Fatia',
        placement: 'Tool',
    },
    {
        id: 'Adobe Slice Select Tool',
        label: 'Ferramenta Seleção de fatia',
        placement: 'Tool',
    },
    {
        id: 'Perspective Grid Tool',
        label: 'Ferramenta Grade de perspectiva',
        placement: 'Tool',
    },
    {
        id: 'Perspective Selection Tool',
        label: 'Ferramenta Seleção de perspectiva',
        placement: 'Tool',
    },
    {
        id: 'Adobe Curvature Tool',
        label: 'Ferramenta Curvatura',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Lasso Tool',
        label: 'Ferramenta Laço',
        placement: 'Tool',
    },
    {
        id: 'Adobe Crop Tool',
        label: 'Ferramenta Prancheta',
        placement: 'Tool',
    },
    {
        id: 'Adobe Reshape Tool',
        label: 'Ferramenta Alterar forma',
        placement: 'Tool',
    },
    {
        id: 'Adobe Width Tool',
        label: 'Ferramenta Largura',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shaper Tool',
        label: 'Ferramenta Shaper',
        placement: 'Tool',
    },
    {
        id: 'Adobe Puppet Warp Tool',
        label: 'Ferramenta Distorção de marionete',
        placement: 'Tool',
    },
    {
        id: 'Adobe Magic Wand Tool',
        label: 'Ferramenta Varinha mágica',
        placement: 'Tool',
    },
    {
        id: 'Adobe Knife Tool',
        label: 'Ferramenta Faca',
        placement: 'Tool',
    },
    {
        id: 'Adobe Free Transform Tool',
        label: 'Ferramenta Transformação livre',
        placement: 'Tool',
    },
    {
        id: 'Adobe Eraser Tool',
        label: 'Ferramenta Borracha',
        placement: 'Tool',
    },
    {
        id: 'Adobe Warp Tool',
        label: 'Ferramenta Deformar',
        placement: 'Tool',
    },
    {
        id: 'Adobe New Twirl Tool',
        label: 'Ferramenta Redemoinho',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pucker Tool',
        label: 'Ferramenta Esvaziar',
        placement: 'Tool',
    },
    {
        id: 'Adobe Bloat Tool',
        label: 'Ferramenta Inflar',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scallop Tool',
        label: 'Ferramenta Guirlanda',
        placement: 'Tool',
    },
    {
        id: 'Adobe Cyrstallize Tool',
        label: 'Ferramenta Cristalizar',
        placement: 'Tool',
    },
    {
        id: 'Adobe Wrinkle Tool',
        label: 'Ferramenta Vincar',
        placement: 'Tool',
    },
    {
        id: 'Adobe Quick Pen Tool',
        label: 'Ferramenta Caneta rápida',
        placement: 'Tool',
    },
    {
        id: 'Adobe Constraints Tool',
        label: 'Objetos no caminho',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rotate Canvas Tool',
        label: 'Ferramenta Girar Visualização',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Tool',
        label: 'Ferramenta Lápis',
        placement: 'Tool',
    },
    {
        id: 'Adobe Brush Tool',
        label: 'Ferramenta Pincel',
        placement: 'Tool',
    },
    {
        id: 'Adobe Blob Brush Tool',
        label: 'Ferramenta Pincel irregular',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Smooth Tool',
        label: 'Ferramenta Suavizar',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Erase Tool',
        label: 'Ferramenta Borracha de caminho',
        placement: 'Tool',
    },
    {
        id: 'Adobe Corner Join Tool',
        label: 'Ferramenta Junção',
        placement: 'Tool',
    },
    {
        id: 'Adobe Eyedropper Tool',
        label: 'Ferramenta Conta-gotas',
        placement: 'Tool',
    },
    {
        id: 'Adobe Ellipse Shape Tool',
        label: 'Ferramenta Elipse',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Regular Polygon Tool',
        label: 'Ferramenta Polígono',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Star Tool',
        label: 'Ferramenta Estrela',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rectangle Shape Tool',
        label: 'Ferramenta Retângulo',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rounded Rectangle Tool',
        label: 'Ferramenta Retângulo arredondado',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Spiral Tool',
        label: 'Ferramenta Espiral',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Sprayer Tool',
        label: 'Ferramenta Pulverizar símbolos',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Shifter Tool',
        label: 'Ferramenta Deslocar símbolos',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Scruncher Tool',
        label: 'Ferramenta Comprimir símbolos',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Sizer Tool',
        label: 'Ferramenta Dimensionar símbolos',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Spinner Tool',
        label: 'Ferramenta Girar símbolos',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Stainer Tool',
        label: 'Ferramenta Colorizar símbolos',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Screener Tool',
        label: 'Ferramenta Transparência de símbolos',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Styler Tool',
        label: 'Ferramenta Estilizar símbolos',
        placement: 'Tool',
    },
    {
        id: 'Adobe Mesh Editing Tool',
        label: 'Ferramenta Malha',
        placement: 'Tool',
    },
    {
        id: 'Adobe Flare Tool',
        label: 'Ferramenta Clarão',
        placement: 'Tool',
    },
    {
        id: 'Adobe Line Tool',
        label: 'Ferramenta Segmento de linha',
        placement: 'Tool',
    },
    {
        id: 'Adobe Arc Tool',
        label: 'Ferramenta Arco',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rectangular Grid Tool',
        label: 'Ferramenta Grade retangular',
        placement: 'Tool',
    },
    {
        id: 'Adobe Polar Grid Tool',
        label: 'Ferramenta Grade polar',
        placement: 'Tool',
    },
    {
        id: '3D and Materials',
        label: '3D e Materiais',
        placement: 'Panel',
    },
    {
        id: 'Actions',
        label: 'Ações',
        placement: 'Panel',
    },
    {
        id: 'AdobeAltGlyphsPanel',
        label: 'Glifos',
        placement: 'Panel',
    },
    {
        id: 'AdobeBrush',
        label: 'Pincéis',
        placement: 'Panel',
    },
    {
        id: 'AdobeCharStyles',
        label: 'Estilos de caractere',
        placement: 'Panel',
    },
    {
        id: 'AdobeColorGuidePanel',
        label: 'Guia de cores',
        placement: 'Panel',
    },
    {
        id: 'AdobeFlatteningPreview',
        label: 'Visualização do nivelador',
        placement: 'Panel',
    },
    {
        id: 'AdobeGradientEditor',
        label: 'Gradiente',
        placement: 'Panel',
    },
    {
        id: 'AdobeHorizontalTabPanel',
        label: 'Tabulações',
        placement: 'Panel',
    },
    {
        id: 'AdobeLayerPalette',
        label: 'Camadas',
        placement: 'Panel',
    },
    {
        id: 'AdobeObjectAttributes',
        label: 'Atributos',
        placement: 'Panel',
    },
    {
        id: 'AdobeOpenTypeFont',
        label: 'OpenType',
        placement: 'Panel',
    },
    {
        id: 'AdobeParaStyles',
        label: 'Estilos de parágrafo',
        placement: 'Panel',
    },
    {
        id: 'AdobePropertiesPanel',
        label: 'Propriedades',
        placement: 'Panel',
    },
    {
        id: 'AdobeSeparationPreview',
        label: 'Visualização de separações',
        placement: 'Panel',
    },
    {
        id: 'AdobeSwatch_',
        label: 'Amostras',
        placement: 'Panel',
    },
    {
        id: 'AdobeVariablesPanel',
        label: 'Variáveis',
        placement: 'Panel',
    },
    {
        id: 'AdobeVerticalTabPanel',
        label: 'Tabulações',
        placement: 'Panel',
    },
    {
        id: 'Align',
        label: 'Alinhar',
        placement: 'Panel',
    },
    {
        id: 'Appearance',
        label: 'Aparência',
        placement: 'Panel',
    },
    {
        id: 'Artboards',
        label: 'Pranchetas',
        placement: 'Panel',
    },
    {
        id: 'CCX Commenting UXP Webview',
        label: 'Comentários',
        placement: 'Panel',
    },
    {
        id: 'CSS',
        label: 'Propriedades CSS (obsoleto)',
        placement: 'Panel',
    },
    {
        id: 'CSXSExtension_com.adobe.DesignLibraries.angular_0',
        label: 'Bibliotecas',
        placement: 'Panel',
    },
    {
        id: 'Character',
        label: 'Caractere',
        placement: 'Panel',
    },
    {
        id: 'Color',
        label: 'Cor',
        placement: 'Panel',
    },
    {
        id: 'Document Info',
        label: 'Informações do documento',
        placement: 'Panel',
    },
    {
        id: 'Export',
        label: 'Exportação de ativos',
        placement: 'Panel',
    },
    {
        id: 'GeneratedVariations',
        label: 'Variações geradas',
        placement: 'Panel',
    },
    {
        id: 'History',
        label: 'Histórico',
        placement: 'Panel',
    },
    {
        id: 'Info',
        label: 'Informações',
        placement: 'Panel',
    },
    {
        id: 'Links',
        label: 'Links',
        placement: 'Panel',
    },
    {
        id: 'Magic Wand',
        label: 'Varinha mágica',
        placement: 'Panel',
    },
    {
        id: 'Mockup',
        label: 'Modelo',
        placement: 'Panel',
    },
    {
        id: 'NamedStyle',
        label: 'Estilos de gráfico',
        placement: 'Panel',
    },
    {
        id: 'Navigator',
        label: 'Navegador',
        placement: 'Panel',
    },
    {
        id: 'Paragraph',
        label: 'Parágrafo',
        placement: 'Panel',
    },
    {
        id: 'Pathfinder',
        label: 'Pathfinder',
        placement: 'Panel',
    },
    {
        id: 'PatternOptionsPanel',
        label: 'Opções de padrão',
        placement: 'Panel',
    },
    {
        id: 'Reflow Viewer',
        label: 'Visualizador do Reflow',
        placement: 'Panel',
    },
    {
        id: 'Retype',
        label: 'Retype',
        placement: 'Panel',
    },
    {
        id: 'SVGInteractivity',
        label: 'Interatividade SVG',
        placement: 'Panel',
    },
    {
        id: 'Stroke',
        label: 'Traçado',
        placement: 'Panel',
    },
    {
        id: 'Symbols',
        label: 'Símbolos',
        placement: 'Panel',
    },
    {
        id: 'Transform',
        label: 'Transformar',
        placement: 'Panel',
    },
    {
        id: 'Transparency',
        label: 'Transparência',
        placement: 'Panel',
    },
    {
        id: 'Vectorize',
        label: 'Traçado da imagem',
        placement: 'Panel',
    },
    {
        id: 'ccx-timeline',
        label: 'Histórico da versão',
        placement: 'Panel',
    },
];
